import LocalizedStrings from "react-localization";

const localizedStrings = new LocalizedStrings({
  en: {
    navigation: {
      changePassword: "Change Password",
      login: "Login",
      logout: "Logout",
      register: "Register",
      applyToday: "Apply Today",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "Prospective Students",
          applyToday: "Apply Today",
          reqesutInfo: "Request Information",
          admissionTest: "Admission Test",
          interviewSelection: "Interview Selection",
        },
        students: {
          students: "Students",
          studentDashboard:"Student Dashboard",
          profile: "Profile",
          financialAid: "Financial Aid",
          degreePlan: "Degree Plan",
          classes: "Classes",
          schedule: "Schedule",
          attendance: "Attendance",
          grades: "Grades",
          selectClasses: "Select Classes",
          activity: "Activity",
          learningAndManagement: "Learning System",
        },
        facultyAndStuff: {
          facultyAndStuff: "Faculty & Staff",
          profile: "Profile",
          classes: "Classes",
          enterAttendance: "Enter Attendance",
          testsAndScore: "Tests & Scores",
          learningAndManagement: "Learning System",
        },
        parents: {
          parents: "Sponsors",
          attendance: "Attendance",
          grades: "Grades",
        },
        alumni: {
          alumni: "Alumni",
          myInfo: "My Information",
          events: "Events",
          opportunities: "Opportunities",
          donations: "Donations",
        },
        events: "Events",
        courseCatalog: "Course Catalog",
        documents: "Documents",
        about: "About",
        invoices: "Account",
       
      },
    },
    footer: {
      students: {
        students: "Students",
        profile: "Profile",
        classes: "Classes",
        attendance: "Attendance",
        schedule: "Schedule",
        grades: "Grades",
        

      },
      facultyAndStaff: {
        facultyAndStaff: "FACULTY & STAFF",
        profile: "Profile",
        classes: "Classes",
        attendance: "Attendance",
        testsAndScore: "Tests & Score",
        learningManagement: " Learning Management",
      },
      contactUs: {
        contactUs: "CONTACT US",
        email: "Email",
        phone: "Phone",
      },
    },
    login: {
      signIn: "Sign In",
      forgotPassword: " Forgot Password",
      registerMessageOne: "Don't have an account",
      registerMessageTwo: "Create a new Account",
      email: "Email Address",
      password: "Password",
      logininwithAD: "Login with AD Account",
    },
    register: {
      register: "Register",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Address",
      password: "Password",
      confirmPassword: "Confirm Password",
      signUpMessage: " Already an account",
      signIn: "Sign In",
      passwordErrorMsg: "Incorrect confirm password.",
      checkPasswordformat:
        "The password should have at least one upper case letter,one lower case letter,one number and be at least eight characters in length.",
      emailErrorMsg: "Invalid Email Address",
    },
    forgotPassword: {
      forgotPassword: "Forgot Password",
      email: "Email Address",
      back: "Back",
      submit: "Submit",
      emailErrorMsg: "Invalid Email Address",
    },
    changePassword: {
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      submit: "Submit",
      cancel: "Cancel",
    },
    application: {
      applyToday: "Apply Today",
      back: "Back",
      save: "Save",
      next: "Next",
      personalInformation: {
        personalInformation: "Personal and Program",
        firstName: "First Name",
        genderCode: {
          genderCode: "Gender *",
          male: "Male",
          female: "Female",
        },
        governmentid: "ID/Passport Number",
        birthDate: "Date Of Birth* (DD/MM/YYYY)",
        lastName: "Last Name",
        middleName: "Middle Name",
        ses_applicant: "Applicant ID",
        ses_birthcountry: "Country of Birth",
        ses_nationality: "Nationality*",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value: "Programs*",
        },
      },
      conatactInformation: {
        conatactInformation: "Contact Information",
        general: {
          general: "General",
          emailaddress1: "Email Address",
          emailaddress2: "Alternate Email Address",
          mobilephone: {
            errorMessage: "Mobile Phone can't be blank",
          },
        },
        homeAddress: {
          homeAddress: "Home Address",
          address1_city: {
            address1_city: "City",
            errorMessage: "City can't be blank",
          },
          address1_country: {
            address1_country: "Country *",
            errorMessage: "Country can't be blank",
          },
          address1_line1: {
            address1_line1: "Street Address",
            errorMessage: "Street Address can't be blank",
          },
          address1_postalcode: "Zip Code/Postal Code",
        },
        legal: {
          legal: "Legal Guardian Information",
          gurd_firstname: {
            gurd_firstname: "First Name",
            errorMessage: "firstname can't be blank",
          },
          gurd_middlename: "Middle Name",
          gurd_lastname: {
            gurd_lastname: "Last Name",
            errorMessage: "lastname can't be blank",
          },
          gurd_birthdate: "Date Of Birth (DD/MM/YYYY)",
          gurd_ses_nationality: "Nationality*",

          gurd_address1_line1: {
            gurd_address1_line1: "Street",
            errorMessage: "Street can't be blank",
          },
          gurd_address1_city: {
            gurd_address1_city: "City",
            errorMessage: "City can't be blank",
          },
          gurd_address1_country: {
            gurd_address1_country: "Country *",
            errorMessage: "Country can't be blank",
          },
          gurd_address1_postalcode: "Zip Code/Postal Code",
          gurd_emailaddress1: {
            gurd_emailaddress1: "Email Address",
            errorMessage: "Email Address can't be blank",
          },
          ses_relationship: {
            ses_relationship: "Relationship with Legal Guardian ",
            father: "Father",
            mother: "Mother",
            guardian: "Guardian",
          },

          gurd_mobilephone: {
            errorMessage: "Mobile Phone Number can't be blank",
          },
        },
        workAddress: {
          workAddress: "Work Address",
          address2_line1: "Street Address",
          address2_city: "City",
          address2_country: "Country *",
          address1_postalcode: "Zip Code/Postal Code",
        },
        mobilePhone: "Mobile Phone",
        homePhone: "Home Phone",
        skypeId: "Skype Id",
      },
      education: {
        education: "Education Information Undergraduate",
        undergraduate: {
          undergraduate: "Secondary School",
          errorMessage: "Secondary School can't be blank",
          ses_country: "Country*",
          ses_graduationyear: "Graduation Year*",
          ses_schoolcontact: {
            ses_schoolcontact: "Faculty",
            errorMessage: "Faculty can't be blank",
          },
          ses_track_value: "Preferred Major*",
          ses_certificateearned: "Other Certificate",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "University",
              errorMessage: "Secondary School can't be blank",
            },
            ses_country: "Country*",
            ses_graduationyear: "Graduation Year*",
            ses_schoolcontact: {
              ses_schoolcontact: "Faculty",
              errorMessage: "Faculty can't be blank",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "Company Name",
              errorMessage: "Company Name can't be blank",
            },
            ses_previousemployment: {
              ses_previousemployment: "Job Title",
              errorMessage: "Job Title can't be blank",
            },
            ses_startdate: "Hiring Date* (DD/MM/YYYY)",
          },
        },
      },
      emergenencyContact: {
        emergenencyContact: "Emergency Contact",
        name: "Name",
        relationship: "Relationship",
        phone: "Emergency Contact Number",
      },
      miscellanous: {
        miscellanous: "Miscellaneous",
        contactMode: "Preferred Method of Contact",
      },
      document: {
        heading: "Application Documents",
        title1: "Document Type",
        title2: "File Name of Uploaded Document",
        types: {
          passport: "Passport",
          transcript: "Transcript",
          photo: "Photo",
          assessment: "Assessment",
          financials: "Financials",
          any: "Any",
        },
      },
    },
    enquiry: {
      save: "Save",
      clear: "Clear",
      testData: "Test Data",
      requestInfo: "Request Information",
      description: `Let us know about you and any questions or comments you might have.
          Please complete the following form and submit it, or send an e-mail to
          admissions@oneworldsis.com.`,
      general: {
        general: "General",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
      },
      conatactInformation: {
        conatactInformation: "Contact Information",
        salutation: "Salutation",
        firstName: "First Name",
        middleName: "Middle Name",
        lastName: "Last Name",
        birthdate: "Birthday",
        mobilePhone: "Mobile Phone",
        telephone1: "Home Phone",
        contactMode: {
          any: "Any",
          email: "Email",
          phone: "phone",
          fax: "Fax",
          mail: "Mail",
        },
        comments: "Enter Comments",
      },
      homeAddress: {
        homeAddress: "Home Address",
        address2_country: "Country *",
        address2_line1: "Street",
        address2_city: "City",
        address2_stateorprovince: "State or Province",
        address2_postalcode: "Zip Code/Postal Code",
      },
      mailingAddress: {
        mailingAddress: "Mailing Address (If Different)",
        address2_country: "Country *",
        address2_line1: "Street",
        address2_city: "City",
        address2_stateorprovince: "State or Province",
        address2_postalcode: "Zip Code/Postal Code",
      },
    },
    students: {
      classes: {
        classes: "Classes",
        refresh: "Refresh",
        table: {
          classId: "Class ID",
          course: "Course",
          classSection: "Class Section",
          credits: "Credits",
          classStatus: "Class Status",
          status: "Status",
          attendance: "Attendance",
          gradingOption: "Grading Option",
          allTerms: "Terms",
          action: "Action",
        },
        attendance: {
          attendance: "Attendance",
          classDate: "Class Date",
          notes: "Notes",
        },
        roster: {
          classRoster: "Class Roster",
          studentId: "Student ID",
          studentName: "Name",
          status: "Status",
          gradeType: "Grading Type",
          percentage: "% Complete",
          numericGrade: "Numeric Grade",
          letterGrade: "Letter Grade",
          creditEarned: "Credits Earned ",
          creditType: "Credit Type"             
        },
      },
      selectClasses: {
        next: "Next",
        total: "Total",
        selectClasses: "Select Classes",
        back: "Back",
        submit: "Submit",
        description: "Description",
        checkoutDescription: `Please review your course selection. Click the Submit button to register your class selections. If the class status is "Available", you will be enrolled in the class. If the class status is "Wait List", you will be added to the wait list for the class.`,
        addNew: "Add New",
        table: {
          term: "Term",
          code: "Code",
          description: "Description",
          classStatus: "Class Status",
          credits: "Credits",
          gradeOption: "Grade Option",
          price: "Price",
          action: "Action",
        },
        modalTable: {
          courseCataLog: "Course Catalog",
          term: "Term",
          allTerms: "Terms",
          allSchools: "Schools",
          department: "Department",
          allDepartments: "Departments",
          course: "Course",
          allCourses: "Courses",
          campus: "Campus",
          allCampuses: "Campuses",
          faculty: "Instructor(s)",
          credits: "Credits",
          enrolled: "Enrolled / Availability",
          firstMeet: "First Meeting",
          price: "Price",
          actions: "Actions",
          close: "Close",
          add: "Add",
          classDates: "Class Dates",
          classDate: "Class Date",
          endDate: "End Date",
          startDate: "Start Date",
          class: "Class",
          credits: "Credits",
          rooms: "Rooms",
          allcourseLevel: "Course Levels",
          courselevel: "Course Level",
          schoolname: "School",
        },
      },
      profile: {
        save: "Save",
        refresh: "Refresh",
        heading: "My Profile",
        primaryDetails: {
          primaryDetails: "Personal Information",
          emailaddress1: "Email Address",
          firstName: "First Name",
          middleName: "Middle Name",
          lastName: "Last Name",
          suffix: "Suffix",
          birthdate: "Birthday",
          genderCode: {
            male: "Male",
            female: "Female",
          },
        },
        contact: {
          contact: "Contact Information",
          mobilePhone: "Mobile Phone",
          telephone1: "Home Phone",
          skypeId: "Skype ID",
        },
        HomeAddress: {
          HomeAddress: "Home Address",
          address1_country: "Country *",
          address1_line1: "Street",
          address1_city: "City",
          address1_stateorprovince: "State or Province",
          address1_postalcode: "Zip Code/Postal Code",
        },
        mailingAddress: {
          mailingAddress: "Mailing Address (If Different)",
          address2_country: "Country *",
          address2_line1: "Street",
          address2_city: "City",
          address2_stateorprovince: "State or Province",
          address2_postalcode: "Zip Code/Postal Code",
        },
        emergenencyContact: {
          emergenencyContact: "Emergency Contact",
          name: "Name",
          relationship: "Relationship",
          phone: "Emergency Contact Number",
        },
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "Save",
        heading: "Enter Attendance",
        selectOne: "Select One",
        term: "Term",
        className: "Class Name",
        NoClassNameMsg: "No class are available for the specified term",
        classDates: "Class Dates",
        noClassDatesMsg:
          "There are no class dates available for entering attendance.",
        table: {
          studentName: "Student Name",
          institutionIdNo: "Institution ID Number",
          present: "Present",
          tardy: "Tardy",
          unexcusedAbsent: "Unexcused Absent",
          excusedAbsent: "Excused Absent",
          remarks: "Remarks",
        },
      },
    },
    homePage: {
      about: {
        about: "About OneWorldSIS Global University",
        desciption:
          "OneWorld Global University was founded to provide the most comprehensive curriculum focused on teaching the core principles of true digital transformation. This program will equip students to assist organizations in developing and implementing digital transformation technology that will allow institutions to achieve their optimal efficiencies and enhance the day to day lives of their constituents.",
      },
      focus: {
        heading: "Our Core Values",
        collegiality: "Collegiality",
        inclusivity: "Inclusivity",
        excellence: "Excellence",
        innovation: "Innovation",
      },
      gallery: {
        studentProfile: "Student Profile",
        classes: "Classes",
        admission: "Admission",
      },
      newsLetter: {
        heading: "Subscribe to our Newsletter for latest news.",
        subscribe: "Subscribe",
        email: "Your-Email",
      },
    },
    general: {
      month: "Month",
      week: "Week",
      day: "Day",
      next: "Next",
      back: "Back",
      today: "Today",
      agenda: "Agenda",
      weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      year: [
        `January`,
        `February`,
        `March`,
        `April`,
        `May`,
        `June`,
        `July`,
        `August`,
        `September`,
        `October`,
        `November`,
        `December`,
      ],
      classStatusAvailable: "Available",
      classStatusFull: "Full",
      classStatusWaitList: "Wait List",
      classStatusCancelled: "Cancelled",
      classStatusClosed: "Closed",
      classStatusCompleted: "Completed",
      StatusWaitList: "Wait list",
      StatusEnrolled: "Enrolled",
      StatusCompleted: "Completed",
      StatusCancelled: "Cancelled",
      StatusIncomplete: "Incomplete",
      StatusDropped: "Dropped",
      StatusTentative: "Tentative",
      StatusTransfer: "Transfer",
    },
  },
  fr: {
    general: {
      month: "Mois",
      week: "Semaine",
      day: "Jour",
      next: "Suivant",
      back: "Précédent",
      today: "Aujourd'hui",
      agenda: "Ordre du jour",
      weekdays: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
      year: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      classStatusAvailable: "Disponible",
      classStatusFull: "Complet",
      classStatusWaitList: "Liste d'attente",
      classStatusCancelled: "Annulé",
      classStatusClosed: "Fermé",
      classStatusCompleted: "Terminé",
      StatusWaitList: "Liste d'attente",
      StatusEnrolled: "Inscrit",
      StatusCompleted: "Terminé",
      StatusCancelled: "Annulé",
      StatusIncomplete: "Incomplet",
      StatusDropped: "Abandonné",
      StatusTentative: "Provisoire",
      StatusTransfer: "Transfert",
    },
    navigation: {
      changePassword: "changeMot de passe",
      login: "connectez-vous",
      logout: "déconnexion",
      register: "registre",
      applyToday: "Postulez dès aujourd’hui",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "Futurs étudiants",
          applyToday: "Postulez dès aujourd’hui",
          reqesutInfo: "Demande d’informations",
          admissionTest: "Test d’admission",
          interviewSelection: "Sélection des entrevues",
        },
        students: {
          students: "Étudiants",
          profile: "Profil",
          degreePlan: "Plan d’études",
          classes: "Classes",
          schedule: "Horaire",
          attendance: "Fréquentation",
          grades: "Notes",
          selectClasses: "Sélectionnez les classes",
          activity: "Activité",
          learningAndManagement: "Apprentissage et gestion",
        },
        facultyAndStuff: {
          facultyAndStuff: "Faculté et trucs",
          profile: "Profil",
          classes: "Classes",
          enterAttendance: "Entrez la présence",
          testsAndScore: "Tests et score",
          learningAndManagement: "Apprentissage et gestion",
        },
        parents: {
          parents: "Parents",
          attendance: "Fréquentation",
          grades: "Notes",
        },
        alumni: {
          alumni: "Anciens",
          myInfo: "Mes infos",
          events: "Épreuves",
          opportunities: "Possibilités",
          donations: "Dons",
        },
        events: "épreuves",
        courseCatalog: "Catalogue des cours",
        documents: "Documents",
        about: "environ",
        invoices: "Compte",
      },
    },
    footer: {
      students: {
        students: "Étudiants",
        profile: "Profil",
        classes: "Classes",
        attendance: "Fréquentation",
        schedule: "Horaire",
        grades: "Notes",
      },
      facultyAndStaff: {
        facultyAndStuff: "Faculté et trucs",
        profile: "Profil",
        classes: "Classes",
        attendance: "Fréquentation",
        testsAndScore: "Tests et score",
        learningAndManagement: "Apprentissage et gestion",
      },
      contactUs: {
        contactUs: "Contactez-nous",
        email: "Messagerie électronique",
        phone: "Téléphone",
      },
    },
    login: {
      signIn: "Connexion",
      forgotPassword: "Mot de passe oublié",
      registerMessageOne: "Enregistrer le premier message",
      registerMessageTwo: "Enregistrer le deuxième message",
      email: "Messagerie électronique",
      password: "mot de passe",
      logininwithAD: "Login with AD Account",
    },
    register: {
      register: "registre",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "Messagerie électronique",
      password: "mot de passe",
      confirmPassword: "Confirmez le mot de passe",
      signUpMessage: "Message d’inscription",
      signIn: "Connexion",
      passwordErrorMsg: "Message d’erreur de mot de passe",
      emailErrorMsg: "Message d’erreur par e-mail",
    },
    forgotPassword: {
      forgotPassword: "Mot de passe oublié",
      email: "Messagerie électronique",
      back: "Précédent",
      submit: "Envoyer",
      emailErrorMsg: "Message d’erreur par e-mail",
    },
    changePassword: {
      changePassword: "changeMot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmNewPassword: "Confirmer le nouveau mot de passe",
      submit: "Envoyer",
      cancel: "Annuler",
    },
    application: {
      applyToday: "Postulez dès aujourd’hui",
      back: "Précédent",
      save: "Sauvegarder",
      next: "Prochain",
      personalInformation: {
        personalInformation: "Renseignements personnels",
        firstName: "Prénom",
        genderCode: {
          genderCode: "Code de genre *",
          male: "Mâle",
          female: "Femelle",
        },
        governmentid: "ID du gouvernement",
        birthDate: "Date de naissance* (jj / mm / aaaa)",
        lastName: "Nom de famille",
        middleName: "Deuxième prénom",
        ses_applicant: "Demandeur",
        ses_birthcountry: "Pays de naissance de",
        ses_nationality: "Nationalité*",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value:
            "Valeur du programme de certification*",
        },
      },
      conatactInformation: {
        conatactInformation: "Coordonnées",
        general: {
          general: "Généralités",
          emailaddress1: "Adresse e-mail",
          emailaddress2: "Adresse e-mail de rechange",
          mobilephone: {
            errorMessage: "Message d'erreur",
          },
        },
        homeAddress: {
          homeAddress: "Adresse du domicile",
          address1_city: {
            address1_city: "Ville",
            errorMessage: "Message d'erreur",
          },
          address1_country: {
            address1_country: "Pays *",
            errorMessage: "Message d'erreur",
          },
          address1_line1: {
            address1_line1: "Ligne d’adresse",
            errorMessage: "Message d'erreur",
          },
          address1_postalcode: "Adresse code postal",
        },
        legal: {
          legal: "légal",
          gurd_firstname: {
            gurd_firstname: "Prénom",
            errorMessage: "Message d'erreur",
          },
          gurd_middlename: "Deuxième nom",
          gurd_lastname: {
            gurd_lastname: "Nom de famille",
            errorMessage: "Message d'erreur",
          },
          gurd_birthdate: "Date de naissance (jj / mm / aaaa)",
          gurd_ses_nationality: "Nationalité",

          gurd_address1_line1: {
            gurd_address1_line1: "Ligne d’adresse",
            errorMessage: "Message d'erreur",
          },
          gurd_address1_city: {
            gurd_address1_city: "Ville",
            errorMessage: "Message d'erreur",
          },
          gurd_address1_country: {
            gurd_address1_country: "Pays *",
            errorMessage: "Message d'erreur",
          },
          gurd_address1_postalcode: "Adresse code postal",
          gurd_emailaddress1: {
            gurd_emailaddress1: "Adresse e-mail",
            errorMessage: "Message d'erreur",
          },
          ses_relationship: {
            ses_relationship: "Relation",
            father: "Père",
            mother: "Mère",
            guardian: "Gardien",
          },

          gurd_mobilephone: {
            errorMessage: "Message d'erreur",
          },
        },
        workAddress: {
          workAddress: "Adresse professionnelle",
          address2_line1: "Ligne d’adresse",
          address2_city: "Ville",
          address2_country: "Pays *",
          address1_postalcode: "Adresse code postal",
        },
        mobilePhone: "Téléphone mobile",
        homePhone: "Téléphone à domicile",
        skypeId: "Identifiant Skype",
      },
      education: {
        education: "Éducation",
        undergraduate: {
          undergraduate: "Étudiant",
          errorMessage: "Message d'erreur",
          ses_country: "Pays*",
          ses_graduationyear: "Année d’obtention du diplôme*",
          ses_schoolcontact: {
            ses_schoolcontact: "Contact avec l’école",
            errorMessage: "Message d'erreur",
          },
          ses_track_value: "Suivre la valeur*",
          ses_certificateearned: "Certificat obtenu",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "École précédente",
              errorMessage: "Message d'erreur",
            },
            ses_country: "Pays*",
            ses_graduationyear: "Année d’obtention du diplôme*",
            ses_schoolcontact: {
              ses_schoolcontact: "Contact avec l’école",
              errorMessage: "Message d'erreur",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "Employeur",
              errorMessage: "Message d'erreur",
            },
            ses_previousemployment: {
              ses_previousemployment: "Emploi précédent",
              errorMessage: "Message d'erreur",
            },
            ses_startdate: "Date d'embauche* (JJ / MM / AAAA)",
          },
        },
      },
      miscellanous: {
        miscellanous: "divers",
        contactMode: "Mode contact",
      },
      emergenencyContact: {
        emergenencyContact: "Contact d’urgence",
        name: "nom",
        relationship: "relation",
        phone: "Téléphone",
      },
      document: {
        heading: "rubrique",
        title1: "Type de document",
        title2: "Nom de fichier du document téléchargé",
        types: {
          passport: "Passeport",
          transcript: "Transcription",
          photo: "Photo",
          assessment: "Évaluation",
          financials: "Données financières",
          any: "Quelconque",
        },
      },
    },
    enquiry: {
      save: "Sauvegarder",
      clear: "clair",
      testData: "Données de test",
      requestInfo: "Demande d’informations",
      description: `Faites-nous part de vous et de vos questions ou commentaires.
          Veuillez remplir le formulaire suivant et le soumettre ou envoyer un e-mail à
          admissions@oneworldsis.com.`,
      general: {
        general: "Généralités",
        email: "Email",
        password: "Mot de passe",
        confirmPassword: "Confirmez le mot de passe",
      },
      conatactInformation: {
        conatactInformation: "Coordonnées",
        salutation: "Salutation",
        firstName: "Prénom",
        middleName: "Deuxième prénom",
        lastName: "Nom de famille",
        birthdate: "Date de naissance",
        mobilePhone: "Téléphone mobile",
        telephone1: "Téléphone fixe",
        contactMode: {
          any: "Quelconque",
          email: "Email",
          phone: "Téléphone",
          fax: "Fax",
          mail: "Courrier",
        },
        comments: "Entrez des commentaires",
      },
      homeAddress: {
        homeAddress: "Adresse du domicile",
        address2_country: "Pays *",
        address2_line1: "rue",
        address2_city: "Ville",
        address2_stateorprovince: "état ou province",
        address2_postalcode: "Adresse code postal",
      },
      mailingAddress: {
        mailingAddress: "Adresse postale (si différente)",
        address2_country: "Pays *",
        address2_line1: "rue",
        address2_city: "Ville",
        address2_stateorprovince: "état ou province",
        address2_postalcode: "Adresse code postal",
      },
    },
    students: {
      classes: {
        classes: "Des classes",
        refresh: "Rafraîchir",
        table: {
          classId: "Identifiant de classe",
          course: "Cours",
          classSection: "Section de classe",
          credits: "Crédits",
          classStatus: "État de la classe",
          status: "Statut",
          attendance: "fréquentation",
          gradingOption: "Option de classement",
          allTerms: "Tous les termes",
          action: "Action",
        },
        attendance: {
          attendance: "fréquentation",
          classDate: "Date de classe",
          notes: "Notes",
        },
      },
      selectClasses: {
        selectClasses: "Sélectionnez Classes",
        addNew: "Ajouter un nouveau",
        back: "Précédent",
        submit: "Envoyer",
        description: "Course description",
        checkoutDescription: `Veuillez revoir votre sélection de cours. Cliquez sur le bouton Soumettre pour enregistrer vos sélections de classe.
                 Si le statut du cours est "Disponible", vous serez inscrit au cours. Si le statut du cours est "Liste d'attente", vous serez ajouté à la 
                 liste d'attente du cours.`,
        next: "prochain",
        total: "total",
        table: {
          term: "Terme",
          code: "Code",
          description: "Description",
          classStatus: "État de la classe",
          credits: "Crédits",
          gradeOption: "Option de grade",
          price: "Prix",
          action: "Action",
        },
        modalTable: {
          courseCataLog: "Cours CataLog",
          term: "Terme",
          allTerms: "Tous les termes",
          department: "département",
          allDepartments: "Tous les départements",
          course: "Cours",
          allCourses: "Tous les cours",
          campus: "Campus",
          allCampuses: "Tous les campus",
          faculty: "faculté",
          credits: "Crédits",
          enrolled: "Inscrit / Disponibilité",
          firstMeet: "Première rencontre",
          price: "Prix",
          actions: "Actions",
          close: "Fermer",
          add: "Ajouter",
          classDates: "Dates des cours",
          classDate: "Date du cours",
          endDate: "Date de fin",
          startDate: "Date de début",
          class: ".Class",
        },
      },
      profile: {
        save: "Sauvegarder",
        refresh: "Rafraîchir",
        heading: "Rubrique",
        primaryDetails: {
          primaryDetails: "Détails principaux",
          emailaddress1: "Adresse e-mail",
          firstName: "Prénom",
          middleName: "Deuxième nom",
          lastName: "Nom de famille",
          suffix: "Suffixe",
          birthdate: "Date de naissance",
          genderCode: {
            male: "Mâle",
            female: "Femelle",
          },
        },
        contact: {
          contact: "Coordonnées",
          mobilePhone: "Téléphone mobile",
          telephone1: "Téléphone fixe",
          skypeId: "Identifiant Skype",
        },
        HomeAddress: {
          HomeAddress: "Adresse du domicile",
          address1_country: "Pays *",
          address1_line1: "rue",
          address1_city: "Ville",
          address1_stateorprovince: "état ou province",
          address1_postalcode: "Adresse code postal",
        },
        mailingAddress: {
          mailingAddress: "Adresse postale (si différente)",
          address2_country: "Pays *",
          address2_line1: "rue",
          address2_city: "Ville",
          address2_stateorprovince: "état ou province",
          address2_postalcode: "Adresse code postal",
        },
        emergenencyContact: {
          emergenencyContact: "Contact d’urgence",
          name: "Nom",
          relationship: "Relation",
          phone: "Téléphone de contact d'urgence",
        },
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "Sauvegarder",
        heading: "rubrique",
        selectOne: "Sélectionnez-en un",
        term: "Terme",
        className: "Nom de la classe",
        NoClassNameMsg: "Aucune classe n'est disponible pour le terme spécifié",
        classDates: "Dates des cours",
        noClassDatesMsg:
          "Il n'y a pas de dates de cours disponibles pour la participation.",
        table: {
          studentName: "Nom de l’étudiant",
          institutionIdNo: "Numéro d'identification de l'institution",
          present: "présent",
          tardy: "Tardif",
          unexcusedAbsent: "non excusé Absent",
          excusedAbsent: "Excusé absent",
          remarks: "Remarques",
        },
      },
    },
    homePage: {
      about: {
        about: "À propos de OneWorldSIS Global University",
        desciption:
          "OneWorld Global University a été fondée pour fournir le programme le plus complet axé sur l'enseignement des principes fondamentaux d'une véritable transformation numérique. Ce programme permettra aux étudiants d'aider les organisations à développer et à mettre en œuvre une technologie de transformation numérique qui permettra aux établissements d'atteindre leur efficacité optimale et d'améliorer la vie quotidienne de leurs électeurs.",
      },
      focus: {
        heading: "Nos valeurs fondamentales",
        collegiality: "Collégialité",
        inclusivity: "Inclusivité",
        excellence: "Excellence",
        innovation: "Innovation",
      },
      gallery: {
        studentProfile: "Profil étudiant",
        classes: "classes",
        admission: "Admission",
      },
      newsLetter: {
        heading:
          "Abonnez-vous à notre newsletter pour les dernières nouvelles.",
        subscribe: "S’inscrire",
        email: "Votre-Email",
      },
    },
  },
  es: {
    navigation: {
      changePassword: "Cambiar contraseña",
      login: "Iniciar sesión",
      logout: "Cerrar sesión",
      register: "registro",
      applyToday: "Aplicar hoy",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "Postulantes",
          applyToday: "Aplicar hoy",
          reqesutInfo: "Solicitar información",
          admissionTest: "Prueba de admisión",
          interviewSelection: "Selección de entrevistas",
        },
        students: {
          students: "estudiantes",
          profile: "perfil",
          degreePlan: "Plan de Grado",
          classes: "Clases",
          schedule: "horario",
          attendance: "Attedance",
          grades: "Grados",
          selectClasses: "Seleccionar clases",
          activity: "actividad",
          learningAndManagement: "Aprendizaje y mangement",
        },
        facultyAndStuff: {
          facultyAndStuff: "Profesores y personal",
          profile: "perfil",
          classes: "Clases",
          enterAttendance: "Entrar en asistencia",
          testsAndScore: "Pruebas & Puntuaciones",
          learningAndManagement: "Aprendizaje & Gestión",
        },
        parents: {
          parents: "padres",
          attendance: "Attandance",
          grades: "Grados",
        },
        alumni: {
          alumni: "egresados",
          myInfo: "Mi información",
          events: "Eventos",
          opportunities: "Oportunidades",
          donations: "Donaciones",
        },
        events: "Eventos",
        courseCatalog: "Catálogo de cursos",
        documents: "Documentos",
        about: "acerca de",
      },
    },
    footer: {
      students: {
        students: "estudiantes",
        profile: "perfil",
        classes: "Clases",
        attendance: "asistencia",
        schedule: "horario",
        grades: "Grados",
      },
      facultyAndStaff: {
        facultyAndStaff: "PROFESORES y PERSONAL",
        profile: "perfil",
        classes: "Clases",
        attendance: "asistencia",
        testsAndScore: "Pruebas & Puntuación",
        learningManagement: " Gestión del aprendizaje",
      },
      contactUs: {
        contactUs: "contáctenos",
        email: "Correo electrónico",
        phone: "Teléfono",
      },
    },
    login: {
      signIn: "Inicia sesión",
      forgotPassword: " Contraseña olvidada",
      registerMessageOne: "No tienes una cuenta",
      registerMessageTwo: "Crear una nueva cuenta",
      email: "Dirección de correo electrónico",
      password: "contraseña",
    },
    register: {
      register: "registro",
      firstName: "nombre",
      lastName: "apellido",
      email: "Dirección de correo electrónico",
      password: "contraseña",
      confirmPassword: "Confirmar contraseña",
      signUpMessage: " Ya es una cuenta",
      signIn: "Inicia sesión",
      passwordErrorMsg: "Las contraseñas no coinciden",
      emailErrorMsg: "Correo electrónico no válido",
    },
    forgotPassword: {
      forgotPassword: "Contraseña olvidada",
      email: "Introduzca su dirección de correo electrónico",
      back: "Atrás",
      submit: "Enviar",
      emailErrorMsg: "Correo electrónico no válido",
    },
    changePassword: {
      changePassword: "Cambiar contraseña",
      currentPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      confirmNewPassword: "Confirmar nueva contraseña",
      submit: "Enviar",
      cancel: "Cancelar",
    },
    application: {
      applyToday: "Aplicar hoy",
      back: "Atrás",
      save: "salvar",
      next: "próximo",
      personalInformation: {
        personalInformation: "Personal y programa",
        firstName: "nombre",
        genderCode: {
          genderCode: "Género *",
          male: "masculino",
          female: "hembra",
        },
        governmentid: "Número de identificación/pasaporte",
        birthDate: "Fecha de nacimiento* (DD/MM/AAAA)",
        lastName: "apellido",
        middleName: "segundo nombre",
        ses_applicant: "Identificación del solicitante",
        ses_birthcountry: "País de nacimiento",
        ses_nationality: "Nacionalidad*",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value: "Programas*",
        },
      },
      conatactInformation: {
        conatactInformation: "Información de contacto",
        general: {
          general: "General",
          emailaddress1: "Dirección de correo electrónico",
          emailaddress2: "Dirección de correo electrónico alternativa",
          mobilephone: {
            errorMessage: "El teléfono móvil no puede estar en blanco",
          },
        },
        homeAddress: {
          homeAddress: "Dirección de inicio",
          address1_city: {
            address1_city: "ciudad",
            errorMessage: "La ciudad no puede estar en blanco",
          },
          address1_country: {
            address1_country: "país *",
            errorMessage: "El país no puede estar en blanco",
          },
          address1_line1: {
            address1_line1: "Dirección de la calle",
            errorMessage: "La dirección de la calle no puede estar en blanco",
          },
          address1_postalcode: "Código Postal/Código Postal",
        },
        legal: {
          legal: "Información de Legal Guardian",
          gurd_firstname: {
            gurd_firstname: "nombre",
            errorMessage: "nombre en primer lugar no puede estar en blanco",
          },
          gurd_middlename: "segundo nombre",
          gurd_lastname: {
            gurd_lastname: "apellido",
            errorMessage: "apellido no puede estar en blanco",
          },
          gurd_birthdate: "Fecha de nacimiento (DD/MM/AAAA)",
          gurd_ses_nationality: "Nacionalidad*",
          gurd_address1_line1: {
            gurd_address1_line1: "calle",
            errorMessage: "La calle no puede estar en blanco",
          },
          gurd_address1_city: {
            gurd_address1_city: "ciudad",
            errorMessage: "La ciudad no puede estar en blanco",
          },
          gurd_address1_country: {
            gurd_address1_country: "país *",
            errorMessage: "El país no puede estar en blanco",
          },
          gurd_address1_postalcode: "Código Postal/Código Postal",
          gurd_emailaddress1: {
            gurd_emailaddress1: "Dirección de correo electrónico",
            errorMessage:
              "La dirección de correo electrónico no puede estar en blanco",
          },
          ses_relationship: {
            ses_relationship: "Relación con Legal Guardian ",
            father: "padre",
            mother: "madre",
            guardian: "guardián",
          },
          gurd_mobilephone: {
            errorMessage:
              "El número de teléfono móvil no puede estar en blanco",
          },
        },
        workAddress: {
          workAddress: "Dirección de trabajo",
          address2_line1: "Dirección de la calle",
          address2_city: "ciudad",
          address2_country: "país *",
          address1_postalcode: "Código Postal/Código Postal",
        },
        mobilePhone: "téléphone mobile",
        homePhone: "Téléphone à domicile",
        skypeId: "Skype Id",
      },
      education: {
        education: "Información de Educación Licenciatura",
        undergraduate: {
          undergraduate: "liceo",
          errorMessage: "La escuela secundaria no puede estar en blanco",
          ses_country: "País*",
          ses_graduationyear: "Año de graduación*",
          ses_schoolcontact: {
            ses_schoolcontact: "facultad",
            errorMessage: "La facultad no puede estar en blanco",
          },
          ses_track_value: "Mayor preferido*",
          ses_certificateearned: "Otro certificado",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "universidad",
              errorMessage: "La escuela secundaria no puede estar en blanco",
            },
            ses_country: "País*",
            ses_graduationyear: "Año de graduación*",
            ses_schoolcontact: {
              ses_schoolcontact: "facultad",
              errorMessage: "La facultad no puede estar en blanco",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "Nombre de la empresa",
              errorMessage: "El nombre de la empresa no puede estar en blanco",
            },
            ses_previousemployment: {
              ses_previousemployment: "Puesto de trabajo",
              errorMessage: "El título de trabajo no puede estar en blanco",
            },
            ses_startdate: "Fecha de contratación* (DD/MM/AAAA)",
          },
        },
      },
      miscellanous: {
        miscellanous: "misceláneo",
        contactMode: "Método de contacto preferido",
      },
      emergenencyContact: {
        emergenencyContact: "Contacto de emergencia",
        name: "nombre",
        relationship: "relación",
        phone: "Teléfono de contacto de emergencia",
      },
      document: {
        heading: "Documentos de solicitud",
        title1: "Tipo de documento",
        title2: "Nombre de archivo del documento cargado",
        types: {
          passport: "pasaporte",
          transcript: "transcripción",
          photo: "foto",
          assessment: "evaluación",
          financials: "Finanzas",
          any: "cualquier",
        },
      },
    },
    enquiry: {
      save: "salvar",
      clear: "claro",
      testData: "Datos de prueba",
      requestInfo: "Solicitar información",
      description:
        "Háganos saber acerca de usted y cualquier pregunta o comentario que pueda tener. Complete el siguiente formulario y envíelo, o envíe un correo electrónico a admissions@oneworldsis.com.",
      general: {
        general: "General",
        email: "Correo electrónico",
        password: "contraseña",
        confirmPassword: "Confirmar contraseña",
      },
      conatactInformation: {
        conatactInformation: "Información de contacto",
        salutation: "saludo",
        firstName: "nombre",
        middleName: "segundo nombre",
        lastName: "apellido",
        birthdate: "cumpleaños",
        mobilePhone: "teléfono móvil",
        telephone1: "Teléfono del hogar",
        contactMode: {
          any: "cualquier",
          email: "Correo electrónico",
          phone: "Teléfono",
          fax: "fax",
          mail: "correo",
        },
        comments: "Introducir comentarios",
      },
      homeAddress: {
        homeAddress: "Domicilio",
        address2_country: "país *",
        address2_line1: "calle",
        address2_city: "ciudad",
        address2_stateorprovince: "Estado o provincia",
        address2_postalcode: "Código Postal/Código Postal",
      },
      mailingAddress: {
        mailingAddress: "Dirección postal (si es diferente)",
        address2_country: "país *",
        address2_line1: "calle",
        address2_city: "ciudad",
        address2_stateorprovince: "Estado o provincia",
        address2_postalcode: "Código Postal/Código Postal",
      },
    },
    students: {
      classes: {
        classes: "Clases",
        refresh: "actualizar",
        table: {
          classId: "Id. de clase",
          course: "curso",
          classSection: "Sección de clases",
          credits: "créditos",
          classStatus: "Estado de la clase",
          status: "estado",
          attendance: "asistencia",
          gradingOption: "Opción de calificación",
          allTerms: "Todos los Términos",
          action: "acción",
        },
        attendance: {
          attendance: "asistencia",
          classDate: "Fecha de clase",
          notes: "Notas",
        },
      },
      selectClasses: {
        next: "próximo",
        total: "total",
        "selectClasses ": "Seleccionar clases",
        back: "Atrás",
        submit: "Enviar",
        checkoutDescription:
          'Por favor revise la selección del curso. Haga clic en el botón Enviar para registrar las selecciones de clase. Si el estado de la clase es "Disponible", se le inscribirá en la clase. Si el estado de la clase es "Lista de espera", se agregará a la lista de espera de la clase.',
        addNew: "Añadir nuevo",
        table: {
          term: "término",
          code: "código",
          description: "descripción",
          classStatus: "Estado de la clase",
          credits: "créditos",
          gradeOption: "Opción de calificación",
          price: "precio",
          action: "acción",
        },
        modalTable: {
          courseCataLog: "Catálogo de cursos",
          term: "término",
          allTerms: "Todos los Términos",
          department: "departamento",
          allDepartments: "Todo el Departamento",
          course: "curso",
          allCourses: "Todos los cursos",
          campus: "campus",
          allCampuses: "Todos los campus",
          faculty: "facultad",
          credits: "créditos",
          enrolled: "Inscrito / Disponibilidad",
          firstMeet: "Primera reunión",
          price: "precio",
          actions: "Acciones",
          close: "cerrar",
          add: "agregar",
          classDates: "Fechas de clase",
          classDate: "Fecha de clase",
          endDate: "fecha final",
          startDate: "fecha de inicio",
          class: "clase",
        },
      },
      profile: {
        save: "salvar",
        refresh: "actualizar",
        heading: "Mi perfil",
        primaryDetails: {
          primaryDetails: "Información personal",
          emailaddress1: "Dirección de correo electrónico",
          firstName: "nombre",
          middleName: "segundo nombre",
          lastName: "apellido",
          suffix: "sufijo",
          birthdate: "cumpleaños",
          genderCode: {
            male: "masculino",
            female: "hembra",
          },
        },
        contact: {
          contact: "Información de contacto",
          mobilePhone: "teléfono móvil",
          telephone1: "Teléfono del hogar",
          skypeId: "Identificador de Skype",
        },
        HomeAddress: {
          HomeAddress: "Domicilio",
          address1_country: "país *",
          address1_line1: "calle",
          address1_city: "ciudad",
          address1_stateorprovince: "Estado o provincia",
          address1_postalcode: "Código Postal/Código Postal",
        },
        mailingAddress: {
          mailingAddress: "Dirección postal (si es diferente)",
          address2_country: "país *",
          address2_line1: "calle",
          address2_city: "ciudad",
          address2_stateorprovince: "Estado o provincia",
          address2_postalcode: "Código Postal/Código Postal",
        },
        emergenencyContact: {
          emergenencyContact: "Contacto de emergencia",
          name: "nombre",
          relationship: "relación",
          phone: "Teléfono de contacto de emergencia",
        },
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "salvar",
        heading: "Entrar en asistencia",
        selectOne: "Seleccione uno",
        term: "término",
        className: "Nombre de clase",
        NoClassNameMsg: "No hay clase disponible para el término especificado",
        classDates: "Fechas de clase",
        noClassDatesMsg:
          "No hay fechas de clase disponibles para entrar en asistencia.",
        table: {
          studentName: "Nombre del estudiante",
          institutionIdNo: "Número de identificación de la institución",
          present: "presente",
          tardy: "tardío",
          unexcusedAbsent: "Ausente injustificado",
          excusedAbsent: "Excusado ausente",
          remarks: "observaciones",
        },
      },
    },
    homePage: {
      about: {
        about: "Acerca de OneWorldSIS Global University",
        desciption:
          "OneWorld Global University se fundó para proporcionar el plan de estudios más completo centrado en enseñar los principios básicos de la verdadera transformación digital. Este programa equipará a los estudiantes para ayudar a las organizaciones a desarrollar e implementar tecnología de transformación digital que permitirá a las instituciones lograr su eficiencia óptima y mejorar la vida cotidiana de sus electores.",
      },
      focus: {
        heading: "Nuestros valores fundamentales",
        collegiality: "colegialidad",
        inclusivity: "Inclusividad",
        excellence: "excelencia",
        innovation: "innovación",
      },
      gallery: {
        studentProfile: "Perfil del estudiante",
        classes: "Clases",
        admission: "admisión",
      },
      newsLetter: {
        heading:
          "Suscríbete a nuestro Boletín para recibir las últimas noticias.",
        subscribe: "subscribir",
        email: "Su correo electrónico",
      },
    },
  },
  zh: {
    navigation: {
      changePassword: "更改密码",
      login: "登录",
      logout: "注销",
      register: "注册",
      applyToday: "立即申请",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "潜在学生",
          applyToday: "立即申请",
          reqesutInfo: "请求信息",
          admissionTest: "入学考试",
          interviewSelection: "面试选择",
        },
        students: {
          students: "学生",
          profile: "轮廓",
          degreePlan: "学位计划",
          classes: "类",
          schedule: "附表",
          attendance: "出席",
          grades: "成绩",
          selectClasses: "选择类",
          activity: "活动",
          learningAndManagement: "学习与操纵",
        },
        facultyAndStuff: {
          facultyAndStuff: "教职员工",
          profile: "轮廓",
          classes: "类",
          enterAttendance: "输入出勤率",
          testsAndScore: "测试和分数",
          learningAndManagement: "学习与管理",
        },
        parents: {
          parents: "父母",
          attendance: "出席",
          grades: "成绩",
        },
        alumni: {
          alumni: "校友",
          myInfo: "我的信息",
          events: "事件",
          opportunities: "机会",
          donations: "捐款",
        },
        events: "事件",
        courseCatalog: "课程目录",
        documents: "文件",
        about: "大约",
      },
    },
    footer: {
      students: {
        students: "学生",
        profile: "轮廓",
        classes: "类",
        attendance: "出席",
        schedule: "附表",
        grades: "成绩",
      },
      facultyAndStaff: {
        facultyAndStaff: "教师和工作人员",
        profile: "轮廓",
        classes: "类",
        attendance: "出席",
        testsAndScore: "测试和分数",
        learningManagement: "学习管理",
      },
      contactUs: {
        contactUs: "联系美国",
        email: "电子邮件",
        phone: "电话",
      },
    },
    login: {
      signIn: "登录",
      forgotPassword: "忘记密码",
      registerMessageOne: "没有帐户",
      registerMessageTwo: "创建新帐户",
      email: "电子邮件地址",
      password: "密码",
    },
    register: {
      register: "注册",
      firstName: "名字",
      lastName: "姓",
      email: "电子邮件地址",
      password: "密码",
      confirmPassword: "确认密码",
      signUpMessage: "已经有一个帐户",
      signIn: "登录",
      passwordErrorMsg: "密码不匹配",
      emailErrorMsg: "无效电子邮件",
    },
    forgotPassword: {
      forgotPassword: "忘记密码",
      email: "输入您的电子邮件地址",
      back: "返回",
      submit: "提交",
      emailErrorMsg: "无效电子邮件",
    },
    changePassword: {
      changePassword: "更改密码",
      currentPassword: "当前密码",
      newPassword: "新密码",
      confirmNewPassword: "确认新密码",
      submit: "提交",
      cancel: "取消",
    },
    application: {
      applyToday: "立即申请",
      back: "返回",
      save: "救",
      next: "下一个",
      personalInformation: {
        personalInformation: "个人和计划",
        firstName: "名字",
        genderCode: {
          genderCode: "性别*",
          male: "雄",
          female: "女性",
        },
        governmentid: "身份证/护照号码",
        birthDate: "出生日期* （DD/MM/YY）",
        lastName: "姓",
        middleName: "中间名",
        ses_applicant: "申请人身份证",
        ses_birthcountry: "出生国",
        ses_nationality: "国籍*",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value: "计划*",
        },
      },
      conatactInformation: {
        conatactInformation: "联系方式",
        general: {
          general: "常规",
          emailaddress1: "电子邮件地址",
          emailaddress2: "备用电子邮件地址",
          mobilephone: {
            errorMessage: "手机不能是空白的",
          },
        },
        homeAddress: {
          homeAddress: "家庭地址",
          address1_city: {
            address1_city: "城市",
            errorMessage: "城市不可能是空白的",
          },
          address1_country: {
            address1_country: "国家",
            errorMessage: "国家不能是空白的",
          },
          address1_line1: {
            address1_line1: "街道地址",
            errorMessage: "街道地址不能是空白的",
          },
          address1_postalcode: "邮政编码/邮政编码",
        },
        legal: {
          legal: "法律监护人信息",
          gurd_firstname: {
            gurd_firstname: "名字",
            errorMessage: "第一个名字不能是空白的",
          },
          gurd_middlename: "中间名",
          gurd_lastname: {
            gurd_lastname: "姓",
            errorMessage: "最后一个名不能是空白的",
          },
          gurd_birthdate: "出生日期 （DD/MM/Y）",
          gurd_ses_nationality: "国籍*",
          gurd_address1_line1: {
            gurd_address1_line1: "街",
            errorMessage: "街道不能是空白的",
          },
          gurd_address1_city: {
            gurd_address1_city: "城市",
            errorMessage: "城市不可能是空白的",
          },
          gurd_address1_country: {
            gurd_address1_country: "国家",
            errorMessage: "国家不能是空白的",
          },
          gurd_address1_postalcode: "邮政编码/邮政编码",
          gurd_emailaddress1: {
            gurd_emailaddress1: "电子邮件地址",
            errorMessage: "电子邮件地址不能是空白的",
          },
          ses_relationship: {
            ses_relationship: "与法定监护人的关系",
            father: "爸爸",
            mother: "妈妈",
            guardian: "监护人",
          },
          gurd_mobilephone: {
            errorMessage: "手机号码不能是空白的",
          },
        },
        workAddress: {
          workAddress: "工作地址",
          address2_line1: "街道地址",
          address2_city: "城市",
          address2_country: "国家",
          address1_postalcode: "邮政编码/邮政编码",
        },

        mobilePhone: "移动电话",
        homePhone: "家庭电话",
        skypeId: "斯凯普伊德",
      },
      education: {
        education: "教育信息 本科",
        undergraduate: {
          undergraduate: "中学",
          errorMessage: "中学不能是空白的",
          ses_country: "国家*",
          ses_graduationyear: "毕业年*",
          ses_schoolcontact: {
            "ses_schoolcontact ": "能力",
            errorMessage: "教师不能是空白的",
          },
          ses_track_value: "首选专业*",
          ses_certificateearned: "其他证书",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "大学",
              errorMessage: "中学不能是空白的",
            },
            ses_country: "国家*",
            ses_graduationyear: "毕业年*",
            ses_schoolcontact: {
              ses_schoolcontact: "能力",
              errorMessage: "教师不能是空白的",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "公司名称",
              errorMessage: "公司名称不能是空白的",
            },
            ses_previousemployment: {
              ses_previousemployment: "职称",
              errorMessage: "职称不能是空白的",
            },
            ses_startdate: "招聘日期* （DD/MM/Y）",
          },
        },
      },
      miscellanous: {
        miscellanous: "杂项",
        contactMode: "首选的接触方式",
      },
      emergenencyContact: {
        emergenencyContact: "紧急联系人",
        name: "名字",
        relationship: "关系",
        phone: "紧急联系电话",
      },
      document: {
        heading: "申请文件",
        title1: "文档类型",
        title2: "上传文档的文件名称",
        types: {
          passport: "护照",
          transcript: "抄本",
          photo: "相片",
          assessment: "评估",
          financials: "财务",
          any: "任何",
        },
      },
    },
    enquiry: {
      save: "救",
      clear: "清楚",
      testData: "测试数据",
      requestInfo: "请求信息",
      description:
        "让我们了解您以及您可能提出的任何问题或评论。请填写以下表格并提交，或发送电子邮件到 admissions@oneworldsis.com.",
      general: {
        general: "常规",
        email: "电子邮件",
        password: "密码",
        confirmPassword: "确认密码",
      },
      conatactInformation: {
        conatactInformation: "联系方式",
        salutation: "称呼",
        firstName: "名字",
        middleName: "中间名",
        lastName: "姓",
        birthdate: "生日",
        mobilePhone: "移动电话",
        telephone1: "家庭电话",
        contactMode: {
          any: "任何",
          email: "电子邮件",
          phone: "电话",
          fax: "传真",
          mail: "邮件",
        },
        comments: "输入评论",
      },
      homeAddress: {
        homeAddress: "家庭地址",
        address2_country: "国家",
        address2_line1: "街",
        address2_city: "城市",
        address2_stateorprovince: "州或省",
        address2_postalcode: "邮政编码/邮政编码",
      },
      mailingAddress: {
        mailingAddress: "邮寄地址（如果不同）",
        address2_country: "国家",
        address2_line1: "街",
        address2_city: "城市",
        address2_stateorprovince: "州或省",
        address2_postalcode: "邮政编码/邮政编码",
      },
    },
    students: {
      classes: {
        classes: "类",
        refresh: "刷新",
        table: {
          classId: "类 ID",
          course: "课程",
          classSection: "类部分",
          credits: "学分",
          classStatus: "类状态",
          status: "地位",
          attendance: "出席",
          gradingOption: "分级选项",
          allTerms: "所有条款",
          action: "行动",
        },
        attendance: {
          attendance: "出席",
          classDate: "上课日期",
          notes: "笔记",
        },
      },
      selectClasses: {
        next: "下一个",
        total: "总",
        selectClasses: "选择类",
        back: "返回",
        submit: "提交",
        checkoutDescription:
          '请查看您的课程选择。单击"提交"按钮以注册您的类选择。 如果类状态为"可用"，您将注册该类。 如果类状态为"等待列表"，则将您添加到类的等待列表中。',
        addNew: "添加新",
        table: {
          term: "术语",
          code: "法典",
          description: "描述",
          classStatus: "类状态",
          credits: "学分",
          gradeOption: "等级选项",
          price: "价格",
          action: "行动",
        },
        modalTable: {
          courseCataLog: "课程目录",
          term: "术语",
          allTerms: "所有条款",
          department: "部门",
          allDepartments: "所有部门",
          course: "课程",
          allCourses: "所有课程",
          campus: "校园",
          allCampuses: "所有校园",
          faculty: "能力",
          credits: "学分",
          enrolled: "已注册/可用性",
          firstMeet: "第一次会议",
          price: "价格",
          actions: "行动",
          close: "关闭",
          add: "加",
          classDates: "上课日期",
          classDate: "上课日期",
          endDate: "结束日期",
          startDate: "开始日期",
          class: "类",
        },
      },
      profile: {
        save: "救",
        refresh: "刷新",
        heading: "我的个人资料",
        primaryDetails: {
          primaryDetails: "个人信息",
          emailaddress1: "电子邮件地址",
          firstName: "名字",
          middleName: "中间名",
          lastName: "姓",
          suffix: "后缀",
          birthdate: "生日",
          genderCode: {
            male: "雄",
            female: "女性",
          },
        },
        contact: {
          contact: "联系方式",
          mobilePhone: "移动电话",
          telephone1: "家庭电话",
          skypeId: "斯凯佩 ID",
        },
        HomeAddress: {
          HomeAddress: "家庭地址",
          address1_country: "国家",
          address1_line1: "街",
          address1_city: "城市",
          address1_stateorprovince: "州或省",
          address1_postalcode: "邮政编码/邮政编码",
        },
        mailingAddress: {
          mailingAddress: "邮寄地址（如果不同）",
          address2_country: "国家",
          address2_line1: "街",
          address2_city: "城市",
          address2_stateorprovince: "州或省",
          address2_postalcode: "邮政编码/邮政编码",
        },
        emergenencyContact: {
          emergenencyContact: "紧急联系人",
          name: "名字",
          relationship: "关系",
          phone: "紧急联系电话",
        },
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "救",
        heading: "输入出勤率",
        selectOne: "选择一个",
        term: "术语",
        className: "类名称",
        NoClassNameMsg: "指定术语不提供类",
        classDates: "上课日期",
        noClassDatesMsg: "没有可用于进入出勤的上课日期。",
        table: {
          studentName: "学生姓名",
          institutionIdNo: "机构身份证号码",
          present: "目前",
          tardy: "缓慢",
          "unexcusedAbsent ": "无故缺席",
          excusedAbsent: "原谅缺席",
          remarks: "言论",
        },
      },
    },
    homePage: {
      about: {
        about: "关于一个世界性全球大学",
        desciption:
          "寰宇一家全球大学的成立是为了提供最全面的课程，重点是教授真正的数字化转型的核心原理。该计划将为学生提供装备，以帮助组织开发和实施数字转换技术，使各机构能够实现最佳效率并改善其选民的日常生活",
      },
      focus: {
        heading: "我们的核心价值观",
        collegiality: "合议制",
        inclusivity: "包容性",
        excellence: "卓越",
        innovation: "创新",
      },
      gallery: {
        studentProfile: "学生简介",
        classes: "类",
        admission: "承认",
      },
      newsLetter: {
        heading: "订阅我们的时事通讯以获得最新消息。",
        subscribe: "订阅",
        email: "您的电子邮件",
      },
    },
  },
  ar: {
    navigation: {
      changePassword: "تغيير كلمة المرور",
      login: "تسجيل الدخول",
      logout: "الخروج",
      register: "سجل",
      applyToday: "تطبيق اليوم",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "الطلاب المحتملين",
          applyToday: "تطبيق اليوم",
          reqesutInfo: "طلب معلومات",
          admissionTest: "اختبار القبول",
          interviewSelection: "اختيار المقابلة",
        },
        students: {
          students: "طلاب",
          profile: "ملف تعريف",
          degreePlan: "خطة الدرجة العلمية",
          classes: "فئات",
          schedule: "جدول",
          attendance: "أتيدانس",
          grades: "الدرجات",
          selectClasses: "تحديد الفئات",
          activity: "نشاط",
          learningAndManagement: "التعلم والمانجمنت",
        },
        facultyAndStuff: {
          facultyAndStuff: "أعضاء هيئة التدريس والموظفين",
          profile: "ملف تعريف",
          classes: "فئات",
          enterAttendance: "أدخل الحضور",
          testsAndScore: "الاختبارات والنتائج",
          learningAndManagement: "التعلم والإدارة",
        },
        parents: {
          parents: "والدان",
          attendance: "أتاندانس",
          grades: "الدرجات",
        },
        alumni: {
          alumni: "الخريجين",
          myInfo: "معلوماتي",
          events: "احداث",
          opportunities: "الفرص",
          donations: "التبرعات",
        },
        events: "احداث",
        courseCatalog: "كتالوج المقرر الدراسي",
        documents: "الوثائق",
        about: "عن",
      },
    },
    footer: {
      students: {
        students: "طلاب",
        profile: "ملف تعريف",
        classes: "فئات",
        attendance: "حضور",
        schedule: "جدول",
        grades: "الدرجات",
      },
      facultyAndStaff: {
        facultyAndStaff: "أعضاء هيئة التدريس والموظفين",
        profile: "ملف تعريف",
        classes: "فئات",
        attendance: "حضور",
        testsAndScore: "الاختبارات والنقاط",
        learningManagement: " إدارة التعلم",
      },
      contactUs: {
        contactUs: "اتصل بنا",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
      },
    },
    login: {
      signIn: "تسجيل الدخول",
      forgotPassword: " نسيت كلمة المرور",
      registerMessageOne: "ليس لديك حساب",
      registerMessageTwo: "إنشاء حساب جديد",
      email: "عنوان البريد الإلكتروني",
      password: "شعار",
    },
    register: {
      register: "سجل",
      firstName: "الاسم الأول",
      lastName: "اسم العائلة",
      email: "عنوان البريد الإلكتروني",
      password: "شعار",
      confirmPassword: "تأكيد كلمة المرور",
      signUpMessage: " حساب بالفعل",
      signIn: "تسجيل الدخول",
      passwordErrorMsg: "كلمات المرور غير متطابقة",
      emailErrorMsg: "بريد إلكتروني غير صالح",
    },
    forgotPassword: {
      forgotPassword: "نسيت كلمة المرور",
      email: "أدخل عنوان بريدك الإلكتروني",
      back: "ظهر",
      submit: "إرسال",
      emailErrorMsg: "بريد إلكتروني غير صالح",
    },
    changePassword: {
      changePassword: "تغيير كلمة المرور",
      currentPassword: "كلمة المرور الحالية",
      newPassword: "كلمة مرور جديدة",
      confirmNewPassword: "تأكيد كلمة المرور الجديدة",
      submit: "إرسال",
      cancel: "إلغاء الأمر",
    },
    application: {
      applyToday: "تطبيق اليوم",
      back: "ظهر",
      save: "أنقذ",
      next: "مقبل",
      personalInformation: {
        personalInformation: "الشخصية والبرنامج",
        firstName: "الاسم الأول",
        genderCode: {
          genderCode: "الجنس *",
          male: "ذكر",
          female: "أنثى",
        },
        governmentid: "رقم ال ID/جواز السفر",
        birthDate: "تاريخ الميلاد* (DD/MM/YYYY)",
        lastName: "اسم العائلة",
        middleName: "الاسم الأوسط",
        ses_applicant: "معرف مقدم الطلب",
        ses_birthcountry: "بلد الميلاد",
        ses_nationality: "الجنسية*",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value: "البرامج*",
        },
      },
      conatactInformation: {
        conatactInformation: "معلومات الاتصال",
        general: {
          general: "عام",
          emailaddress1: "عنوان البريد الإلكتروني",
          emailaddress2: "عنوان البريد الإلكتروني البديل",
          mobilephone: {
            errorMessage: "الهاتف المحمول لا يمكن أن تكون فارغة",
          },
        },
        homeAddress: {
          homeAddress: "عنوان المنزل",
          address1_city: {
            address1_city: "مدينة",
            errorMessage: "المدينة لا يمكن أن تكون فارغة",
          },
          address1_country: {
            address1_country: "بلد",
            errorMessage: "البلد لا يمكن أن يكون فارغا",
          },
          address1_line1: {
            address1_line1: "عنوان الشارع",
            errorMessage: "عنوان الشارع لا يمكن أن يكون فارغا",
          },
          address1_postalcode: "الرمز البريدي / الرمز البريدي",
        },
        legal: {
          legal: "معلومات الوصي القانوني",
          gurd_firstname: {
            gurd_firstname: "الاسم الأول",
            errorMessage: "لا يمكن أن يكون الاسم الأول فارغا",
          },
          gurd_middlename: "الاسم الأوسط",
          gurd_lastname: {
            gurd_lastname: "اسم العائلة",
            errorMessage: "لا يمكن أن يكون اسم العائلة فارغا",
          },
          gurd_birthdate: "تاريخ الميلاد (DD/MM/YYYY)",
          gurd_ses_nationality: "الجنسية*",
          gurd_address1_line1: {
            gurd_address1_line1: "شارع",
            errorMessage: "الشارع لا يمكن أن يكون فارغا",
          },
          gurd_address1_city: {
            gurd_address1_city: "مدينة",
            errorMessage: "المدينة لا يمكن أن تكون فارغة",
          },
          gurd_address1_country: {
            gurd_address1_country: "بلد",
            errorMessage: "البلد لا يمكن أن يكون فارغا",
          },
          gurd_address1_postalcode: "الرمز البريدي / الرمز البريدي",
          gurd_emailaddress1: {
            gurd_emailaddress1: "عنوان البريد الإلكتروني",
            errorMessage: "لا يمكن أن يكون عنوان البريد الإلكتروني فارغا",
          },
          ses_relationship: {
            ses_relationship: "العلاقة مع الوصي القانوني ",
            father: "أب",
            mother: "أم",
            guardian: "حافظ",
          },
          gurd_mobilephone: {
            errorMessage: "لا يمكن أن يكون رقم الهاتف الجوال فارغا",
          },
        },
        workAddress: {
          workAddress: "عنوان العمل",
          address2_line1: "عنوان الشارع",
          address2_city: "مدينة",
          address2_country: "بلد",
          address1_postalcode: "الرمز البريدي / الرمز البريدي",
        },
        mobilePhone: "جوال",
        homePhone: "هاتف المنزل",
        skypeId: "معرف Skype",
      },
      miscellanous: {
        miscellanous: "متنوعه",
        contactMode: "طريقة الاتصال المفضلة",
      },
      emergenencyContact: {
        emergenencyContact: "الاتصال في حالات الطوارئ",
        name: "اسم",
        relationship: "علاقة",
        phone: "هاتف الاتصال في حالات الطوارئ",
      },
      education: {
        education: "التعليم المعلومات الجامعية",
        undergraduate: {
          undergraduate: "المدرسة الثانوية",
          errorMessage: "لا يمكن أن تكون المدرسة الثانوية فارغة",
          ses_country: "البلد*",
          ses_graduationyear: "سنة التخرج*",
          ses_schoolcontact: {
            ses_schoolcontact: "كليه",
            errorMessage: "لا يمكن أن تكون الكلية فارغة",
          },
          ses_track_value: "الرائد المفضل*",
          ses_certificateearned: "شهادة أخرى",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "جامعة",
              errorMessage: "لا يمكن أن تكون المدرسة الثانوية فارغة",
            },
            ses_country: "البلد*",
            ses_graduationyear: "سنة التخرج*",
            ses_schoolcontact: {
              ses_schoolcontact: "كليه",
              errorMessage: "لا يمكن أن تكون الكلية فارغة",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "اسم الشركة",
              errorMessage: "لا يمكن أن يكون اسم الشركة فارغا",
            },
            ses_previousemployment: {
              ses_previousemployment: "المسمى الوظيفي",
              errorMessage: "لا يمكن أن يكون المسمى الوظيفي فارغا",
            },
            ses_startdate: "تاريخ التوظيف* (DD/MM/YYYY)",
          },
        },
      },
      document: {
        heading: "مستندات الطلب",
        title1: "نوع المستند",
        title2: "اسم ملف المستند الذي تم تحميله",
        types: {
          passport: "جواز سفر",
          transcript: "نسخه",
          photo: "الصور",
          assessment: "تقييم",
          financials: "البيانات المالية",
          any: "أي",
        },
      },
    },
    enquiry: {
      save: "أنقذ",
      clear: "واضح",
      testData: "بيانات الاختبار",
      requestInfo: "طلب معلومات",
      description:
        "أخبرنا عنك وعن أي أسئلة أو تعليقات قد تكون لديك. يرجى ملء النموذج التالي وإرساله، أو إرسال بريد إلكتروني إلى admissions@oneworldsis.com.",
      general: {
        general: "عام",
        email: "البريد الإلكتروني",
        password: "شعار",
        confirmPassword: "تأكيد كلمة المرور",
      },
      conatactInformation: {
        conatactInformation: "معلومات الاتصال",
        salutation: "التحيه",
        firstName: "الاسم الأول",
        middleName: "الاسم الأوسط",
        lastName: "اسم العائلة",
        birthdate: "عيد ميلاد",
        mobilePhone: "جوال",
        telephone1: "هاتف المنزل",
        contactMode: {
          any: "أي",
          email: "البريد الإلكتروني",
          phone: "الهاتف",
          fax: "فاكس",
          mail: "بريد",
        },
        comments: "أدخل تعليقات",
      },
      homeAddress: {
        homeAddress: "عنوان المنزل",
        address2_country: "بلد",
        address2_line1: "شارع",
        address2_city: "مدينة",
        address2_stateorprovince: "الولاية أو المقاطعة",
        address2_postalcode: "الرمز البريدي / الرمز البريدي",
      },
      mailingAddress: {
        mailingAddress: "العنوان البريدي (إذا كان مختلفا)",
        address2_country: "بلد",
        address2_line1: "شارع",
        address2_city: "مدينة",
        address2_stateorprovince: "الولاية أو المقاطعة",
        address2_postalcode: "الرمز البريدي / الرمز البريدي",
      },
    },
    students: {
      classes: {
        classes: "فئات",
        refresh: "تحديث",
        table: {
          classId: "معرف الفئة",
          course: "دورة",
          classSection: "قسم الفئة",
          credits: "الائتمانات",
          classStatus: "حالة الفئة",
          status: "حالة",
          attendance: "حضور",
          gradingOption: "خيار التقدير",
          allTerms: "جميع الشروط",
          action: "فعل",
        },
        attendance: {
          attendance: "حضور",
          classDate: "تاريخ الفصل الدراسي",
          notes: "تلاحظ",
        },
      },
      selectClasses: {
        next: "مقبل",
        total: "مجموع",
        selectClasses: "تحديد الفئات",
        back: "ظهر",
        submit: "إرسال",
        checkoutDescription:
          'يرجى مراجعة اختيار المقرر الدراسي. انقر فوق الزر إرسال لتسجيل اختيارات الفصل الدراسي. إذا كانت حالة الفئة "متوفرة"، سيتم تسجيلك في الفصل. إذا كانت حالة الفئة "قائمة انتظار" ، ستتم إضافة إلى قائمة الانتظار للفئة.',
        addNew: "إضافة جديد",
        table: {
          term: "مصطلح",
          code: "رمز",
          description: "وصف",
          classStatus: "حالة الفئة",
          credits: "الائتمانات",
          gradeOption: "خيار التقدير",
          price: "ثمن",
          action: "فعل",
        },
        modalTable: {
          courseCataLog: "كتالوج المقرر الدراسي",
          term: "مصطلح",
          allTerms: "جميع الشروط",
          department: "قسم",
          allDepartments: "جميع الأقسام",
          course: "دورة",
          allCourses: "جميع الدورات",
          campus: "الحرم الجامعي",
          allCampuses: "جميع الجامعات",
          faculty: "كليه",
          credits: "الائتمانات",
          enrolled: "المسجلين / التوافر",
          firstMeet: "الاجتماع الأول",
          price: "ثمن",
          actions: "الاجراءات",
          close: "غلق",
          add: "جمع",
          classDates: "تواريخ الفصل الدراسي",
          classDate: "تاريخ الفصل الدراسي",
          endDate: "تاريخ الانتهاء",
          startDate: "تاريخ البدء",
          class: "فصل",
        },
      },
      profile: {
        save: "أنقذ",
        refresh: "تحديث",
        heading: "ملفي الشخصي",
        primaryDetails: {
          primaryDetails: "معلومات شخصية",
          emailaddress1: "عنوان البريد الإلكتروني",
          firstName: "الاسم الأول",
          middleName: "الاسم الأوسط",
          lastName: "اسم العائلة",
          suffix: "لاحقه",
          birthdate: "عيد ميلاد",
          genderCode: {
            male: "ذكر",
            female: "أنثى",
          },
        },
        contact: {
          contact: "معلومات الاتصال",
          mobilePhone: "جوال",
          telephone1: "هاتف المنزل",
          skypeId: "معرف Skype",
        },
        HomeAddress: {
          HomeAddress: "عنوان المنزل",
          address1_country: "بلد",
          address1_line1: "شارع",
          address1_city: "مدينة",
          address1_stateorprovince: "الولاية أو المقاطعة",
          address1_postalcode: "الرمز البريدي / الرمز البريدي",
        },
        mailingAddress: {
          mailingAddress: "العنوان البريدي (إذا كان مختلفا)",
          address2_country: "بلد",
          address2_line1: "شارع",
          address2_city: "مدينة",
          address2_stateorprovince: "الولاية أو المقاطعة",
          address2_postalcode: "الرمز البريدي / الرمز البريدي",
        },
        emergenencyContact: {
          emergenencyContact: "الاتصال في حالات الطوارئ",
          name: "اسم",
          relationship: "علاقة",
          phone: "هاتف الاتصال في حالات الطوارئ",
        },
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "أنقذ",
        heading: "أدخل الحضور",
        selectOne: "تحديد واحد",
        term: "مصطلح",
        className: "اسم الفئة",
        NoClassNameMsg: "لا توجد فئة متوفرة للفترة المحددة",
        classDates: "تواريخ الفصل الدراسي",
        noClassDatesMsg: "لا توجد تواريخ للفصل الدراسي متاحة للدخول في الحضور.",
        table: {
          studentName: "اسم الطالب",
          institutionIdNo: "رقم معرف المؤسسة",
          present: "قدم",
          tardy: "تاخر",
          unexcusedAbsent: "غياب غير مبرر",
          excusedAbsent: "غياب معذور",
          remarks: "ملاحظات",
        },
      },
    },
    homePage: {
      about: {
        about: "نبذة عن جامعة ون وورلدسيس العالمية",
        desciption:
          "تأسست جامعة OneWorld العالمية لتقديم أكثر المناهج الدراسية شمولاً والتي تركز على تدريس المبادئ الأساسية للتحول الرقمي الحقيقي. سيقوم هذا البرنامج بتجهيز الطلاب لمساعدة المنظمات في تطوير وتنفيذ تكنولوجيا التحول الرقمي التي ستسمح للمؤسسات بتحقيق كفاءاتهم المثلى وتعزيز الحياة اليومية لمكوناتها.",
      },
      focus: {
        heading: "قيمنا الأساسية",
        collegiality: "الزمالة",
        inclusivity: "الشمولية",
        excellence: "التميز",
        innovation: "ابتداع",
      },
      gallery: {
        studentProfile: "نبذة عن الطالب",
        classes: "فئات",
        admission: "القبول",
      },
      newsLetter: {
        heading: "اشترك في نشرتنا الإخبارية للحصول على آخر الأخبار.",
        subscribe: "اشترك",
        email: "البريد الإلكتروني الخاص بك",
      },
    },
  },
  hi: {
    navigation: {
      changePassword: "पासवर्ड बदलें",
      login: "लॉगिन",
      logout: "लॉगआउट",
      register: "पंजीकृत करें",
      applyToday: "आज करें आवेदन",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "भावी छात्र",
          applyToday: "आज करें आवेदन",
          reqesutInfo: "जानकारी का अनुरोध",
          admissionTest: "प्रवेश परीक्षा",
          interviewSelection: "साक्षात्कार चयन",
        },
        students: {
          students: "छात्रों",
          profile: "ख़ाका",
          degreePlan: "डिग्री प्लान",
          classes: "वर्गों",
          schedule: "अनुसूची",
          attendance: "एटेडेंस",
          grades: "ग्रेड",
          selectClasses: "कक्षाएं चुनें",
          activity: "गतिविधि",
          learningAndManagement: "लर्निंग एंड मैंगमेंट",
        },
        facultyAndStuff: {
          facultyAndStuff: "फैकल्टी एंड स्टाफ",
          profile: "ख़ाका",
          classes: "वर्गों",
          enterAttendance: "उपस्थिति दर्ज करें",
          testsAndScore: "टेस्ट और स्कोर",
          learningAndManagement: "लर्निंग एंड मैनेजमेंट",
        },
        parents: {
          parents: "माता-पिता",
          attendance: "अट्टानडांस",
          grades: "ग्रेड",
        },
        alumni: {
          alumni: "पूर्व छात्र",
          myInfo: "मेरी जानकारी",
          events: "घटनाओं",
          opportunities: "अवसर",
          donations: "दान",
        },
        events: "घटनाओं",
        courseCatalog: "कोर्स कैटलॉग",
        documents: "दस्तावेज़",
        about: "करीबन",
      },
    },
    footer: {
      students: {
        students: "छात्रों",
        profile: "ख़ाका",
        classes: "वर्गों",
        attendance: "उपस्थिति",
        schedule: "अनुसूची",
        grades: "ग्रेड",
      },
      facultyAndStaff: {
        facultyAndStaff: "फैकल्टी एंड स्टाफ",
        profile: "ख़ाका",
        classes: "वर्गों",
        attendance: "उपस्थिति",
        testsAndScore: "टेस्ट और स्कोर",
        learningManagement: " लर्निंग मैनेजमेंट",
      },
      contactUs: {
        contactUs: "हमसे संपर्क करें",
        email: "ईमेल",
        phone: "फ़ोन",
      },
    },
    login: {
      signIn: "साइन इन करें",
      forgotPassword: " पासवर्ड भूल गया",
      registerMessageOne: "खाता नहीं है",
      registerMessageTwo: "एक नया खाता बनाएं",
      email: "ईमेल पता",
      password: "पासवर्ड",
    },
    register: {
      register: "पंजीकृत करें",
      firstName: "प्रथम नाम",
      lastName: "कुलनाम",
      email: "ईमेल पता",
      password: "पासवर्ड",
      confirmPassword: "पासवर्ड की पुष्टि करें",
      signUpMessage: " पहले से ही एक खाता",
      signIn: "साइन इन करें",
      passwordErrorMsg: "पासवर्ड मेल नहीं खाते",
      emailErrorMsg: "अमान्य ईमेल",
    },
    forgotPassword: {
      forgotPassword: "पासवर्ड भूल गया",
      email: "अपना ई-मेल पता दर्ज करें",
      back: "शर्त लगाना",
      submit: "जमा करें",
      emailErrorMsg: "अमान्य ईमेल",
    },
    changePassword: {
      changePassword: "पासवर्ड बदलें",
      currentPassword: "वर्तमान पासवर्ड",
      newPassword: "नया पासवर्ड",
      confirmNewPassword: "नए पासवर्ड की पुष्टि करें",
      submit: "जमा करें",
      cancel: "रद्द करना",
    },
    application: {
      applyToday: "आज करें आवेदन",
      back: "शर्त लगाना",
      save: "रक्षा कर",
      next: "अगला",
      personalInformation: {
        personalInformation: "व्यक्तिगत और कार्यक्रम",
        firstName: "प्रथम नाम",
        genderCode: {
          genderCode: "लिंग *",
          male: "पुरुष",
          female: "मादा",
        },
        governmentid: "आईडी/पासपोर्ट नंबर",
        birthDate: "जन्म तिथि * (डीडी/एमएम/वाईवाई)",
        lastName: "कुलनाम",
        middleName: "मध्य नाम",
        ses_applicant: "आवेदक आईडी",
        ses_birthcountry: "जन्म का देश",
        ses_nationality: "राष्ट्रीयता *",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value: "कार्यक्रम *",
        },
      },
      conatactInformation: {
        conatactInformation: "संपर्क जानकारी",
        general: {
          general: "सामान्य",
          emailaddress1: "ईमेल पता",
          emailaddress2: "वैकल्पिक ईमेल पता",
          mobilephone: {
            errorMessage: "मोबाइल फोन खाली नहीं हो सकता",
          },
        },
        homeAddress: {
          homeAddress: "घर का पता",
          address1_city: {
            address1_city: "शहर",
            errorMessage: "शहर खाली नहीं हो सकता",
          },
          address1_country: {
            address1_country: "भूक्षेत्र",
            errorMessage: "देश खाली नहीं हो सकता",
          },
          address1_line1: {
            address1_line1: "सड़क का पता",
            errorMessage: "सड़क का पता खाली नहीं हो सकता",
          },
          address1_postalcode: "ज़िप कोड/पोस्टल कोड",
        },
        legal: {
          legal: "कानूनी अभिभावक जानकारी",
          gurd_firstname: {
            gurd_firstname: "प्रथम नाम",
            errorMessage: "पहला नाम खाली नहीं हो सकता",
          },
          gurd_middlename: "मध्य नाम",
          gurd_lastname: {
            gurd_lastname: "कुलनाम",
            errorMessage: "अंतिम नाम खाली नहीं हो सकता",
          },
          gurd_birthdate: "जन्म तिथि (डीडी/एमएम/YYYY)",
          gurd_ses_nationality: "राष्ट्रीयता *",
          gurd_address1_line1: {
            gurd_address1_line1: "गली",
            errorMessage: "सड़क खाली नहीं हो सकता",
          },
          gurd_address1_city: {
            gurd_address1_city: "शहर",
            errorMessage: "शहर खाली नहीं हो सकता",
          },
          gurd_address1_country: {
            gurd_address1_country: "भूक्षेत्र",
            errorMessage: "देश खाली नहीं हो सकता",
          },
          gurd_address1_postalcode: "ज़िप कोड/पोस्टल कोड",
          gurd_emailaddress1: {
            gurd_emailaddress1: "ईमेल पता",
            errorMessage: "ईमेल पता खाली नहीं हो सकता",
          },
          ses_relationship: {
            ses_relationship: "कानूनी गार्जियन के साथ संबंध ",
            father: "पिता",
            mother: "माँ",
            guardian: "अभिभावक",
          },
          gurd_mobilephone: {
            errorMessage: "मोबाइल फोन नंबर खाली नहीं हो सकता",
          },
        },
        workAddress: {
          workAddress: "कार्य पता",
          address2_line1: "सड़क का पता",
          address2_city: "शहर",
          address2_country: "भूक्षेत्र",
          address1_postalcode: "ज़िप कोड/पोस्टल कोड",
        },
        mobilePhone: "मोबाइल फ़ोन",
        homePhone: "होम फोन",
        skypeId: "स्काइप आईडी",
      },
      miscellanous: {
        miscellanous: "फुटकर",
        contactMode: "संपर्क की पसंदीदा विधि",
      },
      emergenencyContact: {
        emergenencyContact: "आपातकालीन संपर्क",
        name: "नाम",
        relationship: "नाता",
        phone: "आपातकालीन संपर्क फोन",
      },
      education: {
        education: "शिक्षा सूचना स्नातक",
        undergraduate: {
          undergraduate: "सेकंडरी स्‍कूल",
          errorMessage: "माध्यमिक स्कूल खाली नहीं किया जा सकता",
          ses_country: "देश *",
          ses_graduationyear: "स्नातक वर्ष *",
          ses_schoolcontact: {
            ses_schoolcontact: "संकाय",
            errorMessage: "संकाय खाली नहीं किया जा सकता",
          },
          ses_track_value: "पसंदीदा मेजर *",
          ses_certificateearned: "अन्य प्रमाण पत्र",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "विश्‍वविद्यालय",
              errorMessage: "माध्यमिक स्कूल खाली नहीं किया जा सकता",
            },
            ses_country: "देश *",
            ses_graduationyear: "स्नातक वर्ष *",
            ses_schoolcontact: {
              ses_schoolcontact: "संकाय",
              errorMessage: "संकाय खाली नहीं किया जा सकता",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "कंपनी का नाम",
              errorMessage: "कंपनी का नाम खाली नहीं हो सकता",
            },
            ses_previousemployment: {
              ses_previousemployment: "नौकरी का शीर्षक",
              errorMessage: "नौकरी शीर्षक खाली नहीं किया जा सकता है",
            },
            ses_startdate: "हायरिंग डेट * (डीडी/एमएम/YYYY)",
          },
        },
      },
      document: {
        heading: "आवेदन दस्तावेज",
        title1: "दस्तावेज़ प्रकार",
        title2: "अपलोड किए गए दस्तावेज का फाइल नाम",
        types: {
          passport: "पासपोर्ट",
          transcript: "प्रतिलिपि",
          photo: "फोटो",
          assessment: "मूल्यांकन",
          financials: "वित्तीय",
          any: "कोई",
        },
      },
    },
    enquiry: {
      save: "रक्षा कर",
      clear: "स्पष्ट",
      testData: "टेस्ट डेटा",
      requestInfo: "जानकारी का अनुरोध",
      description:
        "हमें आपके बारे में और आपके किसी भी प्रश्न या टिप्पणियों के बारे में पता है। कृपया निम्नलिखित प्रपत्र को पूरा करें और इसे सबमिट करें, या admissions@oneworldsis.com को एक ई-मेल भेजें।",
      general: {
        general: "सामान्य",
        email: "ईमेल",
        password: "पासवर्ड",
        confirmPassword: "पासवर्ड की पुष्टि करें",
      },
      conatactInformation: {
        conatactInformation: "संपर्क जानकारी",
        salutation: "अभिवादन",
        firstName: "प्रथम नाम",
        middleName: "मध्य नाम",
        lastName: "कुलनाम",
        birthdate: "जन्‍मदिवस",
        mobilePhone: "मोबाइल फ़ोन",
        telephone1: "होम फोन",
        contactMode: {
          any: "कोई",
          email: "ईमेल",
          phone: "फ़ोन",
          fax: "फ़ैक्स",
          mail: "डाक",
        },
        comments: "टिप्पणियां दर्ज करें",
      },
      homeAddress: {
        homeAddress: "घर का पता",
        address2_country: "भूक्षेत्र",
        address2_line1: "गली",
        address2_city: "शहर",
        address2_stateorprovince: "राज्य या प्रांत",
        address2_postalcode: "ज़िप कोड/पोस्टल कोड",
      },
      mailingAddress: {
        mailingAddress: "मेलिंग पता (यदि अलग है)",
        address2_country: "भूक्षेत्र",
        address2_line1: "गली",
        address2_city: "शहर",
        address2_stateorprovince: "राज्य या प्रांत",
        address2_postalcode: "ज़िप कोड/पोस्टल कोड",
      },
    },
    students: {
      classes: {
        classes: "वर्गों",
        refresh: "आराम देना",
        table: {
          classId: "क्लास आईडी",
          course: "गमन",
          classSection: "कक्षा अनुभाग",
          credits: "क्रेडिट्स",
          classStatus: "कक्षा की स्थिति",
          status: "ओहदा",
          attendance: "उपस्थिति",
          gradingOption: "ग्रेडिंग विकल्प",
          allTerms: "सभी शर्तें",
          action: "मुक़दमा",
        },
        attendance: {
          attendance: "उपस्थिति",
          classDate: "कक्षा तिथि",
          notes: "नोट्स",
        },
      },
      selectClasses: {
        next: "अगला",
        total: "कुल",
        selectClasses: "कक्षाएं चुनें",
        back: "शर्त लगाना",
        submit: "जमा करें",
        checkoutDescription:
          'कृपया अपने पाठ्यक्रम चयन की समीक्षा करें। अपनी कक्षा चयन रजिस्टर करने के लिए सबमिट बटन पर क्लिक करें। यदि कक्षा की स्थिति "उपलब्ध" है, तो आपको कक्षा में नामांकित किया जाएगा। यदि कक्षा की स्थिति "प्रतीक्षा सूची" है, तो आपको कक्षा के लिए प्रतीक्षा सूची में जोड़ा जाएगा।',
        addNew: "नया जोड़ें",
        table: {
          term: "अवधि",
          code: "कोड",
          description: "या क़िस्‍म",
          classStatus: "कक्षा की स्थिति",
          credits: "क्रेडिट्स",
          gradeOption: "ग्रेड विकल्प",
          price: "दाम",
          action: "मुक़दमा",
        },
        modalTable: {
          courseCataLog: "कोर्स कैटलॉग",
          term: "अवधि",
          allTerms: "सभी शर्तें",
          department: "मंत्रालय",
          allDepartments: "सभी विभाग",
          course: "गमन",
          allCourses: "सभी पाठ्यक्रम",
          campus: "कैंपस",
          allCampuses: "सभी परिसरों",
          faculty: "संकाय",
          credits: "क्रेडिट्स",
          enrolled: "नामांकित/उपलब्धता",
          firstMeet: "पहली बैठक",
          price: "दाम",
          actions: "कार्यों",
          close: "बंद करना",
          add: "आगे कहना",
          classDates: "कक्षा तिथियां",
          classDate: "कक्षा तिथि",
          endDate: "अंतिम तिथि",
          startDate: "प्रारंभ तिथि",
          class: "कक्षा",
        },
      },
      profile: {
        save: "रक्षा कर",
        refresh: "आराम देना",
        heading: "मेरा प्रोफाइल",
        primaryDetails: {
          primaryDetails: "व्यक्तिगत जानकारी",
          emailaddress1: "ईमेल पता",
          firstName: "प्रथम नाम",
          middleName: "मध्य नाम",
          lastName: "कुलनाम",
          suffix: "अनुलग्‍न",
          birthdate: "जन्‍मदिवस",
          genderCode: {
            male: "पुरुष",
            female: "मादा",
          },
        },
        contact: {
          contact: "संपर्क जानकारी",
          mobilePhone: "मोबाइल फ़ोन",
          telephone1: "होम फोन",
          skypeId: "स्काइप आईडी",
        },
        HomeAddress: {
          HomeAddress: "घर का पता",
          address1_country: "भूक्षेत्र",
          address1_line1: "गली",
          address1_city: "शहर",
          address1_stateorprovince: "राज्य या प्रांत",
          address1_postalcode: "ज़िप कोड/पोस्टल कोड",
        },
        mailingAddress: {
          mailingAddress: "मेलिंग पता (यदि अलग है)",
          address2_country: "भूक्षेत्र",
          address2_line1: "गली",
          address2_city: "शहर",
          address2_stateorprovince: "राज्य या प्रांत",
          address2_postalcode: "ज़िप कोड/पोस्टल कोड",
        },
        emergenencyContact: {
          emergenencyContact: "आपातकालीन संपर्क",
          name: "नाम",
          relationship: "नाता",
          phone: "आपातकालीन संपर्क फोन",
        },
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "रक्षा कर",
        heading: "उपस्थिति दर्ज करें",
        selectOne: "एक का चयन करें",
        term: "अवधि",
        className: "कक्षा का नाम",
        NoClassNameMsg: "निर्दिष्ट अवधि के लिए कोई कक्षा उपलब्ध नहीं है",
        classDates: "कक्षा तिथियां",
        noClassDatesMsg:
          "उपस्थिति दर्ज करने के लिए कोई कक्षा तिथियां उपलब्ध नहीं हैं।",
        table: {
          studentName: "छात्र का नाम",
          institutionIdNo: "संस्था आईडी नंबर",
          present: "उपस्थित",
          tardy: "सुस्त",
          unexcusedAbsent: "बिना अक्षम अनुपस्थित",
          excusedAbsent: "माफ़ अनुपस्थित",
          remarks: "टिप्पणियां",
        },
      },
    },
    homePage: {
      about: {
        about: "OneWorldSIS ग्लोबल यूनिवर्सिटी के बारे में",
        desciption:
          "वनवर्ल्ड ग्लोबल यूनिवर्सिटी की स्थापना वास्तविक डिजिटल परिवर्तन के मूल सिद्धांतों को पढ़ाने पर केंद्रित सबसे व्यापक पाठ्यक्रम प्रदान करने के लिए की गई थी। यह कार्यक्रम छात्रों को डिजिटल परिवर्तन प्रौद्योगिकी के विकास और कार्यान्वयन में संगठनों की सहायता करने के लिए तैयार करेगा जो संस्थानों को उनकी इष्टतम क्षमता प्राप्त करने और उनके घटकों के दिन-प्रतिदिन के जीवन को बढ़ाने की अनुमति देगा।",
      },
      focus: {
        heading: "हमारे मूल मूल्य",
        collegiality: "कोलेजियम",
        inclusivity: "समावेशन",
        excellence: "उत्‍कृष्‍टता",
        innovation: "नवीनता",
      },
      gallery: {
        studentProfile: "छात्र प्रोफाइल",
        classes: "वर्गों",
        admission: "स्‍वीकरण",
      },
      newsLetter: {
        heading: "नवीनतम समाचार के लिए हमारे समाचार पत्र की सदस्यता लें।",
        subscribe: "सदस्यता लें",
        email: "आपका ईमेल",
      },
    },
  },
  de: {
    navigation: {
      changePassword: "Passwort ändern",
      login: "Login",
      logout: "Logout",
      register: "Registrieren",
      applyToday: "Bewerben Sie sich heute",
      menu: {
        prospectiveStudents: {
          prospectiveStudents: "Angehende Studierende",
          applyToday: "Bewerben Sie sich heute",
          reqesutInfo: "Informationen anfordern",
          admissionTest: "Zulassungstest",
          interviewSelection: "Interview-Auswahl",
        },
        students: {
          students: "Studenten",
          profile: "Profil",
          degreePlan: "Studienplan",
          classes: "Klassen",
          schedule: "Zeitplan",
          attendance: "Teilnahme",
          grades: "Klasse",
          selectClasses: "Klassen auswählen",
          activity: "Aktivität",
          learningAndManagement: "Lernen & Mangement",
        },
        facultyAndStuff: {
          facultyAndStuff: "Fakultät & Personal",
          profile: "Profil",
          classes: "Klassen",
          enterAttendance: "Anwesenheit eingeben",
          testsAndScore: "Tests & Ergebnisse",
          learningAndManagement: "Lernen & Management",
        },
        parents: {
          parents: "Eltern",
          attendance: "Teilnahme",
          grades: "Klasse",
        },
        alumni: {
          alumni: "Alumni",
          myInfo: "Meine Informationen",
          events: "Ereignisse",
          opportunities: "Möglichkeiten",
          donations: "Spenden",
        },
        events: "Ereignisse",
        courseCatalog: "Kurskatalog",
        documents: "Dokumente",
        about: "Über",
      },
    },
    footer: {
      students: {
        students: "Studenten",
        profile: "Profil",
        classes: "Klassen",
        attendance: "Teilnahme",
        schedule: "Zeitplan",
        grades: "Klasse",
      },
      facultyAndStaff: {
        facultyAndStaff: "FAKULTÄT & MITARBEITER",
        profile: "Profil",
        classes: "Klassen",
        attendance: "Teilnahme",
        testsAndScore: "Tests & Score",
        learningManagement: " Lernmanagement",
      },
      contactUs: {
        contactUs: "kontaktieren Sie uns",
        email: "E-Mail",
        phone: "Telefon",
      },
    },
    login: {
      signIn: "Anmelden",
      forgotPassword: " Passwort vergessen",
      registerMessageOne: "Kein Konto haben",
      registerMessageTwo: "Erstellen eines neuen Kontos",
      email: "E-Mail-Adresse",
      password: "Passwort",
    },
    register: {
      register: "Registrieren",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail-Adresse",
      password: "Passwort",
      confirmPassword: "Passwort bestätigen",
      signUpMessage: " Bereits ein Konto",
      signIn: "Anmelden",
      passwordErrorMsg: "Kennwörter stimmen nicht überein",
      emailErrorMsg: "Ungültige E-Mail",
    },
    forgotPassword: {
      forgotPassword: "Passwort vergessen",
      email: "Geben Sie Ihre E-Mail-Adresse ein",
      back: "Zurück",
      submit: "Senden",
      emailErrorMsg: "Ungültige E-Mail",
    },
    changePassword: {
      changePassword: "Passwort ändern",
      currentPassword: "Aktuelles Passwort",
      newPassword: "Neues Passwort",
      confirmNewPassword: "Neues Passwort bestätigen",
      submit: "Senden",
      cancel: "Abbrechen",
    },
    application: {
      applyToday: "Bewerben Sie sich heute",
      back: "Zurück",
      save: "Speichern",
      next: "nächster",
      personalInformation: {
        personalInformation: "Persönlich und Programm",
        firstName: "Vorname",
        genderCode: {
          genderCode: "Geschlecht *",
          male: "Männlich",
          female: "Weiblich",
        },
        governmentid: "ID/Pass-Nummer",
        birthDate: "Geburtsdatum* (DD/MM/JJJJ)",
        lastName: "Nachname",
        middleName: "Zweitname",
        ses_applicant: "Bewerber-ID",
        ses_birthcountry: "Geburtsland",
        ses_nationality: "Nationalität*",
        _ses_certificationprogram_value: {
          _ses_certificationprogram_value: "Programme*",
        },
      },
      conatactInformation: {
        conatactInformation: "Kontaktinformationen",
        general: {
          general: "Allgemein",
          emailaddress1: "E-Mail-Adresse",
          emailaddress2: "Alternative E-Mail-Adresse",
          mobilephone: {
            errorMessage: "Handy darf nicht leer sein",
          },
        },
        homeAddress: {
          homeAddress: "Home-Adresse",
          address1_city: {
            address1_city: "Stadt",
            errorMessage: "Stadt kann nicht leer sein",
          },
          address1_country: {
            address1_country: "Land *",
            errorMessage: "Land darf nicht leer sein",
          },
          address1_line1: {
            address1_line1: "Straßenadresse",
            errorMessage: "Straßenadresse darf nicht leer sein",
          },
          address1_postalcode: "Postleitzahl/Postleitzahl",
        },
        legal: {
          legal: "Legal Guardian Informationen",
          gurd_firstname: {
            gurd_firstname: "Vorname",
            errorMessage: "Vorname darf nicht leer sein",
          },
          gurd_middlename: "Zweitname",
          gurd_lastname: {
            gurd_lastname: "Nachname",
            errorMessage: "Nachname darf nicht leer sein",
          },
          gurd_birthdate: "Geburtsdatum (DD/MM/JJJJ)",
          gurd_ses_nationality: "Nationalität*",
          gurd_address1_line1: {
            gurd_address1_line1: "Street",
            errorMessage: "Straße darf nicht leer sein",
          },
          gurd_address1_city: {
            gurd_address1_city: "Stadt",
            errorMessage: "Stadt kann nicht leer sein",
          },
          gurd_address1_country: {
            gurd_address1_country: "Land *",
            errorMessage: "Land darf nicht leer sein",
          },
          gurd_address1_postalcode: "Postleitzahl/Postleitzahl",
          gurd_emailaddress1: {
            gurd_emailaddress1: "E-Mail-Adresse",
            errorMessage: "E-Mail-Adresse darf nicht leer sein",
          },
          ses_relationship: {
            ses_relationship: "Beziehung zum Legal Guardian ",
            father: "Vater",
            mother: "Mutter",
            guardian: "Wächter",
          },
          gurd_mobilephone: {
            errorMessage: "Mobiltelefonnummer darf nicht leer sein",
          },
        },
        workAddress: {
          workAddress: "Arbeitsadresse",
          address2_line1: "Straßenadresse",
          address2_city: "Stadt",
          address2_country: "Land *",
          address1_postalcode: "Postleitzahl/Postleitzahl",
        },
        mobilePhone: "Handy",
        homePhone: "Home Telefon",
        skypeId: "Skype-Id",
      },
      miscellanous: {
        miscellanous: "Sonstige",
        contactMode: "Bevorzugte Kontaktmethode",
      },
      emergenencyContact: {
        emergenencyContact: "Notfallkontakt",
        name: "Namen",
        relationship: "Beziehung",
        phone: "Notfall-Kontakt-Telefon",
      },
      education: {
        education: "Education Information Undergraduate",
        undergraduate: {
          undergraduate: "Sekundarschule",
          errorMessage: "Sekundarschule kann nicht leer sein",
          ses_country: "Land*",
          ses_graduationyear: "Abschlussjahr*",
          ses_schoolcontact: {
            ses_schoolcontact: "Fakultät",
            errorMessage: "Fakultät kann nicht leer sein",
          },
          ses_track_value: "Bevorzugtes Major*",
          ses_certificateearned: "Sonstiges Zertifikat",
        },
        graduate: {
          prevEducation: {
            ses_previousschool: {
              ses_previousschool: "Universität",
              errorMessage: "Sekundarschule kann nicht leer sein",
            },
            ses_country: "Land*",
            ses_graduationyear: "Abschlussjahr*",
            ses_schoolcontact: {
              ses_schoolcontact: "Fakultät",
              errorMessage: "Fakultät kann nicht leer sein",
            },
          },
          prevEmployment: {
            ses_employer: {
              ses_employer: "Firmenname",
              errorMessage: "Firmenname darf nicht leer sein",
            },
            ses_previousemployment: {
              ses_previousemployment: "Stellentitel",
              errorMessage: "Auftragstitel darf nicht leer sein",
            },
            ses_startdate: "Einstellungsdatum* (DD/MM/Jjjj)",
          },
        },
      },
      document: {
        heading: "Bewerbungsunterlagen",
        title1: "Dokumenttyp",
        title2: "Dateiname des hochgeladenen Dokuments",
        types: {
          passport: "Pass",
          transcript: "Abschrift",
          photo: "Foto",
          assessment: "Bewertung",
          financials: "Financials",
          any: "jegliche",
        },
      },
    },
    enquiry: {
      save: "Speichern",
      clear: "Klar",
      testData: "Testdaten",
      requestInfo: "Informationen anfordern",
      description:
        "Teilen Sie uns mit, welche Fragen oder Kommentare Sie haben. Füllen Sie bitte das folgende Formular aus und senden Sie es ab, oder senden Sie eine E-Mail an admissions@oneworldsis.com.",
      general: {
        general: "Allgemein",
        email: "E-Mail",
        password: "Passwort",
        confirmPassword: "Passwort bestätigen",
      },
      conatactInformation: {
        conatactInformation: "Kontaktinformationen",
        salutation: "Anrede",
        firstName: "Vorname",
        middleName: "Zweitname",
        lastName: "Nachname",
        birthdate: "Geburtstag",
        mobilePhone: "Handy",
        telephone1: "Home Telefon",
        contactMode: {
          any: "jegliche",
          email: "E-Mail",
          phone: "Telefon",
          fax: "Fax",
          mail: "Mail",
        },
        comments: "Kommentare eingeben",
      },
      homeAddress: {
        homeAddress: "Wohnadresse",
        address2_country: "Land *",
        address2_line1: "Street",
        address2_city: "Stadt",
        address2_stateorprovince: "Bundesland oder Provinz",
        address2_postalcode: "Postleitzahl/Postleitzahl",
      },
      mailingAddress: {
        mailingAddress: "Postanschrift (falls abweichend)",
        address2_country: "Land *",
        address2_line1: "Street",
        address2_city: "Stadt",
        address2_stateorprovince: "Bundesland oder Provinz",
        address2_postalcode: "Postleitzahl/Postleitzahl",
      },
    },
    students: {
      classes: {
        classes: "Klassen",
        refresh: "Aktualisieren",
        table: {
          classId: "Klassen-ID",
          course: "Kurs",
          classSection: "Klassenabschnitt",
          credits: "Credits",
          classStatus: "Klassenstatus",
          status: "Status",
          attendance: "Teilnahme",
          gradingOption: "Bewertungsoption",
          allTerms: "Alle Bedingungen",
          action: "Aktion",
        },
        attendance: {
          attendance: "Teilnahme",
          classDate: "Klassendatum",
          notes: "Notizen",
        },
      },
      selectClasses: {
        next: "nächster",
        total: "gesamt",
        selectClasses: "Klassen auswählen",
        back: "Zurück",
        submit: "Senden",
        checkoutDescription:
          'Bitte überprüfen Sie Ihre Kursauswahl. Klicken Sie auf die Schaltfläche Senden, um Ihre Klassenauswahl zu registrieren. Wenn der Klassenstatus "Verfügbar" lautet, werden Sie in der Klasse registriert. Wenn der Klassenstatus "Warteliste" lautet, werden Sie der Warteliste für die Klasse hinzugefügt.',
        addNew: "Neue hinzufügen",
        table: {
          term: "Begriff",
          code: "Code",
          description: "Beschreibung",
          classStatus: "Klassenstatus",
          credits: "Credits",
          gradeOption: "Grade-Option",
          price: "Preis",
          action: "Aktion",
        },

        modalTable: {
          courseCataLog: "Kurskatalog",
          term: "Begriff",
          allTerms: "Alle Bedingungen",
          department: "Abteilung",
          allDepartments: "Alle Abteilungen",
          course: "Kurs",
          allCourses: "Alle Kurse",
          campus: "Campus",
          allCampuses: "Alle Campusse",
          faculty: "Fakultät",
          credits: "Credits",
          enrolled: "Angemeldet / Verfügbarkeit",
          firstMeet: "Erstes Treffen",
          price: "Preis",
          actions: "Aktionen",
          close: "Schließen",
          add: "Hinzufügen",
          classDates: "Klassendaten",
          classDate: "Klassendatum",
          endDate: "Enddatum",
          startDate: "Startdatum",
          class: "Klasse",
        },
      },
      profile: {
        save: "Speichern",
        refresh: "Aktualisieren",
        heading: "Mein Profil",
        primaryDetails: {
          primaryDetails: "Persönliche Daten",
          emailaddress1: "E-Mail-Adresse",
          firstName: "Vorname",
          middleName: "Zweitname",
          lastName: "Nachname",
          suffix: "Suffix",
          birthdate: "Geburtstag",
          genderCode: {
            male: "Männlich",
            female: "Weiblich",
          },
        },
        contact: {
          contact: "Kontaktinformationen",
          mobilePhone: "Handy",
          telephone1: "Home Telefon",
          skypeId: "Skype-ID",
        },
        HomeAddress: {
          HomeAddress: "Wohnadresse",
          address1_country: "Land *",
          address1_line1: "Street",
          address1_city: "Stadt",
          address1_stateorprovince: "Bundesland oder Provinz",
          address1_postalcode: "Postleitzahl/Postleitzahl",
        },
        mailingAddress: {
          mailingAddress: "Postanschrift (falls abweichend)",
          address2_country: "Land *",
          address2_line1: "Street",
          address2_city: "Stadt",
          address2_stateorprovince: "Bundesland oder Provinz",
          address2_postalcode: "Postleitzahl/Postleitzahl",
        },
        emergenencyContact: {
          emergenencyContact: "Notfallkontakt",
          name: "Namen",
          relationship: "Beziehung",
          phone: "Notfall-Kontakt-Telefon",
        },
      },
    },
    facultyAndStuff: {
      attendance: {
        save: "Speichern",
        heading: "Anwesenheit eingeben",
        selectOne: "Wählen Sie eine",
        term: "Begriff",
        className: "Klassenname",
        NoClassNameMsg:
          "Für den angegebenen Begriff ist keine Klasse verfügbar.",
        classDates: "Klassendaten",
        noClassDatesMsg: "Es sind keine Kursdaten für die Teilnahme verfügbar.",
        table: {
          studentName: "Schülername",
          institutionIdNo: "Institutions-ID-Nummer",
          present: "Präsent",
          tardy: "Tardy",
          unexcusedAbsent: "Unentschuldigt Abwesend",
          excusedAbsent: "Entschuldigt Abwesend",
          remarks: "Bemerkungen",
        },
      },
    },
    homePage: {
      about: {
        about: "Über OneWorldSIS Global University",
        desciption:
          "Die OneWorld Global University wurde gegründet, um das umfassendste Curriculum bereitzustellen, das sich auf die Vermittlung der Grundprinzipien einer echten digitalen Transformation konzentriert. Dieses Programm wird die Schüler in die Lage versetzen, Organisationen bei der Entwicklung und Implementierung digitaler Transformationstechnologien zu unterstützen, die es Institutionen ermöglichen, ihre optimale Effizienz zu erreichen und das tägliche Leben ihrer Mitgliedsgruppen zu verbessern.",
      },
      focus: {
        heading: "Unsere Kernwerte",
        collegiality: "Kollegialität",
        inclusivity: "Inklusivität",
        excellence: "Exzellenz",
        innovation: "Innovation",
      },
      gallery: {
        studentProfile: "Studentenprofil",
        classes: "Klassen",
        admission: "Eintritt",
      },
      newsLetter: {
        heading:
          "Abonnieren Sie unseren Newsletter für neuigkeiten Nachrichten.",
        subscribe: "Abonnieren",
        email: "Ihre E-Mail",
      },
    },
  },
});

export default localizedStrings;
